export default {
  trade: 'بازرگانی',
  financialAndEconomicServices: 'خدمات مالی و اقتصادی',
  accountingAuditingTaxConsultingAndFinancialServices:
    'حسابداری حسابرسی مشاوره مالیاتی و خدمات مالی',
  humanResourcesPerformanceEvaluation: 'ارزیابی عملکرد منابع انسانی',
  goldTrading: 'خرید و فروش طلا',
  digitalCurrency: 'ارز دیجیتالی',
  tradeCard: 'کارت بازرگانی',
  financialSystem: 'سیستم مالی',
  investmentConsulting: 'مشاور سرمایه گذاری',
  insuranceAgency: 'نمایندگی بیمه',
  insuranceCompany: 'شرکت بیمه',
  officialBooksSealing: 'پلمپ دفاتر',
  safeSale: 'فروش گاوصندوق',
  managementAndFinancialSystemDesignAndImplementation:
    'طراحی و اجرای سیستم مدیریت و مالی',
  leasing: 'لیزینگ',
  other: 'سایر',
  tradeServices: 'خدمات بازرگانی',
  digitalMarketing: 'بازاریابی دیجیتال',
  goodsCustomsClearance: 'ترخیص کالا',
  goodsDistribution: 'پخش کالا',
  tradeConsulting: 'مشاوره بازرگانی',
  chamberOfCommerce: 'اتاق بازرگانی',
  goodsInspection: 'بازرسی کالا',
  foreignCompanyRepresentativeOffice: 'دفتر نمایندگی شرکت خارجی',
  managementConsulting: 'مشاوره مدیریت',
  customs: 'گمرک',
  importAndExport: 'واردات و صادرات',
  crystalAndCrystalWareImportExport: 'واردات صادرات بلور و کریستال',
  carImport: 'واردات خودرو',
  autoSparePartsImportExport: 'واردات صادرات لوازم یدکی خودرو',
  rimAndTireImportExport: 'واردات صادرات رینگ و لاستیک',
  motorcycleSparePartsImport: 'واردات لوازم یدکی موتورسیکلت',
  leatherAndSalamoorImportExport: 'واردات و صادرات چرم و سالامبور',
  flowerAndPlantImportExport: 'واردات صادرات گل و گیاه',
  fruitAndVegetableImportExport: 'واردات صادرات میوه و تره بار',
  nutAndDriedFruitImportExport: 'واردات صادرات آجیل و خشکبار',
  foodStuffImportExport: 'واردات صادرات مواد غذایی',
  fabricImportExport: 'واردات و صادرات پارچه',
  clothingImportExport: 'واردات و صادرات پوشاک',
  carpetAndRugExport: 'صادرات فرش و قالی',
  paperAndCardboardImportExport: 'واردات صادرات کاغذ و مقوا',
  eyeglassesImport: 'واردات عینک',
  medicalEquipmentImport: 'واردات تجهیزات پزشکی',
  dentalEquipmentImport: 'واردات تجهیزات دندانپزشکی',
  chemicalSubstancesImportExport: 'واردات صادرات مواد شیمیایی',
  medicineImport: 'واردات دارو',
  cosmeticAndHygienicProductsImportExport:
    'واردات و صادرات محصولات آرایشی بهداشتی',
  sportsEquipmentImport: 'واردات لوازم ورزشی',
  bearingAndOilSealImport: 'واردات بلبرینگ و کاسه نمد خودرو',
  adhesiveImportExport: 'واردات و صادرات چسب',
  filterPaperImport: 'واردات کاغذ فیلتر',
  agriculturalProductsImport: 'واردات محصولات کشاورزی',
  dateExport: 'صادرات خرما',
  watchImport: 'واردات ساعت',
  goodsImportExport: 'واردات صادرات کالا',
  toyImport: 'واردات اسباب بازی',
  industryImportExport: 'واردات صادارات - صنعت',
  oilGasAndPetrochemicalRefineryEquipmentImport:
    'واردات تجهیزات پالایشگاهی نفت و گاز و پتروشیمی',
  industrialToolsImportExport: 'واردات صادرات ابزار صنعتی',
  oilGasAndPetrochemicalProductsImportExport:
    'واردات صادرات فرآورده نفت و گاز و پتروشیمی',
  ironImportExport: 'واردات و صادرات آهن',
  screwNutAndNailAndRivetImportExport: 'واردات و صادرات پیچ و مهره و میخ و پرچ',
  glassAndMirrorImportExport: 'واردات صادرات شیشه و آینه',
  telecommunicationsAndWireAndCablePartsImportExport:
    'واردات و صادرات اتصالات و قطعات سیم و کابل',
  industrialAndAgriculturalMachineryImport: 'واردات ماشین آلات صنعتی و کشاورزی',
  agriculturalAndGardeningSeedsSaleAndImport:
    'فروش و واردات بذر کشاورزی و باغبانی',
  toolsAndFittingsImportExport: 'واردات صادرات ابزار و یراق',
  laboratoryMaterialsImport: 'واردات مواد آزمایشگاهی',
  filterImportExport: 'واردات صادرات فیلتر',
  craneImport: 'واردات جرثقیل',
  constructionMachineryImport: 'واردات ماشین آلات ساختمانی',
  agriculturalAndLivestockMachineryImport:
    'واردات ماشین آلات کشاورزی و دامپروری',
  buildingImportExport: 'واردات صادرات - ساختمان',
  tileAndCeramicImportExport: 'واردات صادرات کاشی و سرامیک',
  faucetAndFittingsImportExport: 'واردات صادرات شیرآلات',
  householdAppliancesImport: 'واردات لوازم خانگی',
  buildingAndDecorativeStoneImportExport: 'واردات صادرات سنگ ساختمانی و تزیینی',
  cabinetEquipmentImportExport: 'واردات صادرات تجهیزات کابینت',
  buildingSanitarySuppliesImportExport: 'واردات صادرات لوازم بهداشتی ساختمان',
  constructionToolsImportExport: 'واردات صادرات ابزار ساختمانی',
  lockAndKeyImport: 'واردات قفل و کلید',
  constructionMaterialImportExport: 'واردات و صادرات کالای ساختمانی',
  electronicsSuppliesImportExport: 'واردات صادرات - لوازم الکترونیک',
  electricalSuppliesImportExport: 'واردات و صادرات لوازم الکتریکی',
  computerPeripheralsImport: 'واردات لوازم جانبی کامپیوتر',
  officeMachineryImport: 'واردات ماشین اداری',
  mobilePhoneImport: 'واردات موبایل',
  monitorImport: 'واردات مانیتور',
  electronicComponentsImportExport: 'واردات صادرات قطعات الکترونیک',
  electronicEquipmentImportExport: 'واردات و صادرات تجهیزات الکترونیک',
  computerHardwareComponentsImport: 'واردات قطعات سخت افزار کامپیوتر',
  networkEquipmentImport: 'واردات تجهیزات شبکه',
  medicalAndHealth: 'پزشکی و سلامت',
  specialistPhysician: 'پزشک متخصص',
  cardiologist: 'متخصص قلب و عروق',
  diabetologist: 'دیابتولوژیست',
  rhinoplastySurgeon: 'جراحی زیبایی بینی',
  medicalGenetics: 'ژنتیک پزشکی',
  pulmonaryFunctionTest: 'تست ریه',
  obstetricianAndGynecologist: 'متخصص زنان و زایمان',
  otorhinolaryngologist: 'متخصص گوش حلق و بینی',
  dermatologist: 'متخصص پوست و مو',
  nutritionist: 'متخصص تغذیه',
  generalSurgeon: 'متخصص جراحی عمومی',
  neurosurgeon: 'متخصص جراحی مغز و اعصاب',
  psychiatrist: 'روانپزشک',
  neurologist: 'متخصص مغز و اعصاب',
  generalPractitioner: 'پزشک عمومی',
  clinicalPsychologist: 'روانشناس بالینی',
  familyPhysician: 'پزشک خانواده',
  ophthalmologist: 'چشم پزشک',
  midwifery: 'مامایی',
  orthopedicSurgeon: 'متخصص ارتوپدی و جراحی استخوان و مفاصل',
  urologist: 'متخصص جراحی کلیه مجاری ادراری و تناسلی',
  chiropractor: 'متخصص کایروپرکتیک',
  allergist: 'متخصص آلرژی',
  infectiousDiseaseSpecialist: 'متخصص بیماری های عفونی',
  pathologist: 'متخصص آسیب شناسی',
  clinicalPathologist: 'متخصص آسیب شناسی بالینی',
  anesthesiologist: 'متخصص بیهوشی',
  reproductiveBiologySpecialist: 'متخصص بیولوژی تولید مثل',
  forensicMedicineSpecialist: 'متخصص پزشکی قانونی',
  nuclearMedicineSpecialist: 'متخصص پزشکی هسته ای',
  internist: 'متخصص داخلی',
  radiotherapist: 'متخصص رادیوتراپی',
  radiologist: 'متخصص رادیولوژی',
  molecularGeneticist: 'متخصص ژنتیک مولوکولی',
  rehabilitationSpecialist: 'متخصص توانبخشی',
  laboratorySciencesSpecialist: 'متخصص علوم آزمایشگاهی',
  homeopath: 'متخصص هومیوپاتی',
  socialMedicineAndPreventiveMedicineSpecialist:
    'متخصص پزشکی اجتماعی و طب پیشگیری',
  psychometrist: 'متخصص روانسنجی',
  endocrinologistAndMetabolismSpecialist: 'متخصص غدد درون ریز و متابولیسم',
  subspecialistPhysician: 'پزشک فوق تخصص',
  cardiologySubspecialist: 'فوق تخصص قلب و عروق',
  interventionalCardiologySubspecialist: 'فوق تخصص اینترونشنال کاردیولوژی',
  angioplastyAndValvuloplastySubspecialist:
    'فوق تخصص آنژیوپلاستی و والولوپلاستی',
  pulmonologySubspecialist: 'فوق تخصص ریه',
  endocrinologyAndMetabolismSubspecialist: 'فوق تخصص غدد درون ریز و متابولیسم',
  nephrologySubspecialist: 'فوق تخصص کلیه و مجاری ادراری',
  gastroenterologySubspecialist: 'فوق تخصص گوارش',
  painSubspecialist: 'فوق تخصص درد',
  hematologyAndOncologySubspecialist: 'فوق تخصص خون و سرطان',
  spineSubspecialist: 'فوق تخصص ستون فقرات',
  shoulderSubspecialist: 'فوق تخصص شانه',
  boneAndJointSubspecialist: 'فوق تخصص استخوان و مفاصل',
  ankleSubspecialist: 'فوق تخصص مچ پا',
  kneeSubspecialist: 'فوق تخصص زانو',
  infertilitySubspecialist: 'فوق تخصص نازایی',
  intensiveCareSubspecialist: 'فوق تخصص مراقبت های ویژه',
  openHeartAnesthesiaSubspecialist: 'فوق تخصص بیهوشی قلب باز',
  plasticSurgerySubspecialist: 'فوق تخصص جراحی پلاستیک',
  larynxSurgerySubspecialist: 'فوق تخصص جراحی حنجره',
  breastCancerSurgerySubspecialist: 'فوق تخصص جراحی سرطان سینه',
  gastrointestinalSurgerySubspecialist: 'فوق تخصص جراحی گوارش',
  urologicalSurgerySubspecialist: 'فوق تخصص جراحی کلیه مجاری ادراری و تناسلی',
  headAndNeckSurgerySubspecialist: 'فوق تخصص جراحی سر و گردن',
  kidneyTransplantSurgerySubspecialist: 'فوق تخصص جراحی پیوند کلیه',
  thoracicSurgerySubspecialist: 'فوق تخصص جراحی قفسه سینه',
  cardiovascularSurgerySubspecialist: 'فوق تخصص جراحی قلب و عروق',
  colorectalSurgerySubspecialist: 'فوق تخصص جراحی روده و مقعد',
  handSurgerySubspecialist: 'فوق تخصص جراحی دست',
  ophthalmicPlasticAndReconstructiveSurgerySubspecialist:
    'فوق تخصص جراحی پلاستیک و ترمیمی چشم',
  retinaSubspecialist: 'فوق تخصص شبکیه',
  corneaSubspecialist: 'فوق تخصص قرنیه',
  glaucomaSubspecialist: 'فوق تخصص گلوکوم',
  allergySubspecialist: 'فوق تخصص آلرژی',
  pediatricSpecialist: 'پزشک متخصص کودکان',
  pediatrician: 'متخصص کودکان',
  pediatricOtorhinolaryngologist: 'متخصص گوش و حلق و بینی کودکان',
  neonatologySubspecialist: 'فوق تخصص نوزادان',
  pediatricOphthalmologist: 'چشم پزشک کودکان',
  pediatricEndocrinologySubspecialist: 'فوق تخصص غدد کودکان',
  pediatricGastroenterologySubspecialist: 'فوق تخصص گوارش کودکان',
  pediatricNeurologySubspecialist: 'فوق تخصص مغز و اعصاب کودکان',
  childAndAdolescentPsychiatrist: 'روانپزشک کودکان',
  psychologistForExceptionalChildren: 'روانشناس کودکان استثنایی',
  pediatricOrthopedicsSubspecialist: 'فوق تخصص ارتوپدی کودکان',
  pediatricAllergySubspecialist: 'فوق تخصص آلرژی کودکان',
  pediatricSurgerySubspecialist: 'فوق تخصص جراحی کودکان',
  pediatricHematologyAndOncologySubspecialist: 'فوق تخصص خون و سرطان کودکان',
  pediatricInfectiousDiseasesSubspecialist: 'فوق تخصص عفونی کودکان',
  pediatricCardiologySubspecialist: 'فوق تخصص قلب و عروق کودکان',
  pediatricNephrologySubspecialist: 'فوق تخصص کلیه کودکان',
  dentist: 'دندانپزشک',
  dentalSurgeon: 'جراح دندانپزشک',
  orthodontist: 'متخصص ارتودنسی',
  implantologist: 'متخصص ایمپلنت',
  restorativeAndCosmeticDentist: 'متخصص دندانپزشکی ترمیمی و زیبایی',
  oralAndMaxillofacialSurgeon: 'متخصص جراحی دهان فک و صورت',
  experiencedDentist: 'دندانپزشک تجربی',
  pediatricDentist: 'دندانپزشک کودکان',
  oralMedicineSpecialist: 'متخصص بیماری های دهان',
  periodontist: 'متخصص بیماری های لثه',
  prosthodontist: 'متخصص پروتز دندان',
  endodontist: 'متخصص ریشه دندان',
  experiencedDenturist: 'دندانسازی تجربی',
  denturist: 'دندانسازی',
  hospitals: 'بیمارستان ها',
  hospital: 'بیمارستان',
  cardiologyHospital: 'بیمارستان قلب و عروق',
  obstetricsAndGynecologyHospital: 'بیمارستان زنان و زایمان',
  otorhinolaryngologyHospital: 'بیمارستان گوش حلق و بینی',
  urologyHospital: 'بیمارستان کلیه و مجاری ادراری',
  burnHospital: 'بیمارستان سوانح سوختگی',
  psychiatricHospital: 'بیمارستان روانپزشکی',
  orthopedicHospital: 'بیمارستان ارتوپدی',
  ophthalmologyHospital: 'بیمارستان چشم پزشکی',
  pulmonaryHospital: 'بیمارستان ریه',
  cancerHospital: 'بیمارستان سرطان',
  pediatricHospital: 'بیمارستان کودکان',
  clinicsAndMedicalCenters: 'کلینیک و درمانگاه',
  medicalCenter: 'درمانگاه',
  dentalClinic: 'کلینیک دندانپزشکی',
  hairTransplantClinic: 'کلینیک کاشت مو',
  cardiologyClinic: 'کلینیک قلب و عروق',
  audiologyClinic: 'کلینیک شنوایی سنجی',
  ophthalmologyClinic: 'کلینیک چشم پزشکی',
  orthopedicsClinic: 'کلینیک ارتوپدی',
  nutritionClinic: 'کلینیک تغذیه',
  dermatologyClinic: 'کلینیک پوست و مو',
  allergyClinic: 'کلینیک آلرژی',
  psychiatricClinic: 'کلینیک روانپزشکی',
  homeopathyClinic: 'کلینیک هومیوپاتی',
  nuclearMedicineClinic: 'کلینیک پزشکی هسته ای',
  sleepDisordersClinic: 'کلینیک اختلالات خواب',
  addictionTreatmentClinic: 'کلینیک ترک اعتیاد',
  limitedAndOutpatientSurgeryClinic: 'کلینیک جراحی محدود و سرپایی',
  specializedPainClinic: 'کلینیک تخصصی درد',
  acupunctureClinic: 'کلینیک طب سوزنی',
  speechTherapyClinic: 'کلینیک گفتار درمانی',
  infertilityClinic: 'کلینیک ناباروری',
  hepatitisClinic: 'کلینیک هپاتیت',
  orthoticsAndProsthetics: 'ارتوپدی فنی',
  audiology: 'شنوایی سنجی',
  physiotherapyClinic: 'کلینیک فیزیوتراپی',
  psychologyClinic: 'کلینیک روانشناسی',
  diagnosisAndTreatmentCenters: 'مراکز تشخیص و درمان',
  medicalImagingCenter: 'مرکز تصویربرداری پزشکی',
  radiotherapy: 'رادیوتراپی',
  endoscopy: 'آندوسکوپی (کولونسکوپی EGD)',
  hypnotherapy: 'هیپنوتراپی',
  neurotherapyCenter: 'مرکز نوروتراپی',
  medicalDiagnosticLaboratory: 'آزمایشگاه تشخیص طبی',
  healthcareCenter: 'مرکز بهداشتی درمانی',
  virologyLaboratory: 'آزمایشگاه ویروس شناسی',
  marriageAndFamilyCounselingCenter: 'مرکز مشاوره ازدواج و خانواده',
  medicalBuilding: 'ساختمان پزشکان',
  nerveAndMuscleElectromyography: 'نوار عصب و عضله',
  electrocardiogram: 'نوار قلب',
  electroencephalogram: 'نوار مغز',
  emergencyCenter: 'مرکز اورژانس',
  nursingHome: 'خانه سالمندان',
  veteransSanatorium: 'آسایشگاه جانبازان',
  disabledSanatorium: 'آسایشگاه معلولین',
  orphanageAndInfantHome: 'پرورشگاه و شیرخوارگاه',
  veterinaryMedicine: 'دامپزشکی',
  massageTherapy: 'ماساژ درمانی',
  healthCenter: 'مرکز بهداشت',
  healthHouse: 'خانه بهداشت',
  rehabilitationCenter: 'مرکز توانبخشی',
  welfareOrganization: 'بهزیستی',
  socialWork: 'مددکاری اجتماعی',
  laserTherapy: 'لیزر درمانی',
  complementaryMedicine: 'طب مکمل',
  bloodTransfusionBase: 'پایگاه انتقال خون',
  optometry: 'بینایی سنجی',
  physiotherapy: 'فیزیوتراپی',
  geneticCounseling: 'مشاوره ژنتیک',
  occupationalTherapy: 'کاردرمانی',
  speechTherapy: 'گفتار درمانی',
  chemotherapy: 'شیمی درمانی',
  yumiHoTherapy: 'یومی هو تراپی',
  pathobiologyLaboratory: 'آزمایشگاه پاتوبیولوژی',
  medicalServices: 'خدمات پزشکی',
  forensicMedicine: 'پزشکی قانونی',
  homeMedicalServices: 'خدمات پزشکی در منزل',
  ambulance: 'آمبولانس',
  healthcareConsultingAndServices: 'مشاوره و خدمات بهداشتی درمانی',
  occupationalHealthAndMedicine: 'بهداشت حرفه ای و طب کار',
  nutritionExpert: 'کارشناس تغذیه',
  medicine: 'دارو',
  pharmacy: 'داروخانه',
  roundTheClockPharmacy: 'داروخانه شبانه روزی',
  veterinaryPharmacy: 'داروخانه دامپزشکی',
  pharmaceuticals: 'داروسازی',
  pharmaceuticalRawMaterialsProduction: 'تولید مواد اولیه دارو',
  medicineDistribution: 'پخش دارو',
  herbalMedicineDistribution: 'پخش دارو گیاهی',
  herbalMedicineForLivestockAndPoultryDistribution: 'پخش دارو گیاهی دام و طیور',
  medicalEquipment: 'تجهیزات پزشکی',
  ophthalmicEquipmentSales: 'فروش تجهیزات چشم پزشکی',
  dentalEquipmentRepair: 'تعمیر تجهیزات دندانپزشکی',
  beautyAndSlimmingEquipmentSales: 'فروش تجهیزات زیبایی و لاغری',
  dentalEquipmentSales: 'فروش تجهیزات دندانپزشکی',
  laboratoryEquipmentSales: 'فروش تجهیزات آزمایشگاهی',
  medicalLaboratoryEquipment: 'تجهیزات آزمایشگاه پزشکی',
  medicalEquipmentProductionAndDistribution: 'تولید و پخش تجهیزات پزشکی',
  dentalEquipmentProductionAndDistribution: 'تولید و پخش تجهیزات دندانپزشکی',
  orthopedicEquipmentProduction: 'تولید تجهیزات ارتوپدی',
  laboratoryEquipmentProduction: 'تولید تجهیزات آزمایشگاهی',
  medicalEquipmentRepair: 'تعمیر تجهیزات پزشکی',
  laboratoryEquipmentRepair: 'تعمیر تجهیزات آزمایشگاهی',
  hearingAidsAndAssistiveListeningDevices: 'سمعک و لوازم کمک شنوایی',
  pharmaceuticalAndHygienicContainers: 'ظروف دارویی و بهداشتی',
  disposableMedicalEquipment: 'تجهیزات پزشکی یکبار مصرف',
  veterinaryEquipment: 'تجهیزات دامپزشکی',
  medicalEquipmentSales: 'فروش تجهیزات پزشکی',
  opticalManufacturing: 'عینک سازی',
  traditionalMedicine: 'طب سنتی',
  traditionalMedicineClinic: 'کلینیک طب سنتی',
  traditionalMedicineSpecialist: 'متخصص طب سنتی',
  acupuncturist: 'متخصص طب سوزنی',
  clothingAndJewelry: 'پوشاک و زیورآلات',
  clothingAndJewelrySales: 'فروش پوشاک و زیورآلات',
  boutique: 'بوتیک',
  stroller: 'کالسکه',
  womensClothingSales: 'فروش لباس زنانه',
  mensClothingSales: 'فروش لباس مردانه',
  childrensClothingSales: 'فروش لباس بچه گانه',
  babySetSales: 'فروش سیسمونی',
  sportswearAndEquipmentSales: 'فروش لوازم و پوشاک ورزشی',
  shoeSales: 'فروش کفش',
  bagAndLuggageSales: 'فروش کیف و چمدان',
  militaryClothingSales: 'فروش لباس نظامی',
  workAndSafetyClothingSales: 'فروش لباس کار و ایمنی',
  sewingSuppliesSales: 'فروش لوازم دوخت و دوز',
  underwearSales: 'فروش لباس زیر',
  leatherProductsSales: 'فروش مصنوعات چرمی',
  sportsShoes: 'کفش ورزشی',
  weddingDress: 'لباس عروس',
  textiles: 'منسوجات',
  syntheticLeather: 'چرم مصنوعی',
  secondHandClothing: 'لباس دست دوم',
  tentAndTarpaulin: 'چادر و برزنت',
  mourningReligiousGroupEmblem: 'علامت هیات عزاداری',
  goldAndJewelrySales: 'فروش طلا و جواهر',
  watchSales: 'فروش ساعت',
  promotionalWatch: 'ساعت تبلیغاتی',
  clothingAndJewelryServices: 'خدمات پوشاک و زیورآلات',
  tailoring: 'خیاطی',
  textileChemicalsSales: 'فروش مواد شیمیایی نساجی',
  fashionDesign: 'طراحی لباس',
  clothingServices: 'خدمات پوشاک',
  shoeRepair: 'تعمیر کفش',
  shoemakingSupplies: 'لوازم کفاشی',
  fabricDistribution: 'پخش پارچه',
  fabricServices: 'خدمات پارچه',
  textileIndustry: 'نساجی',
  textileServices: 'خدمات نساجی',
  textileRawMaterials: 'مواد اولیه نساجی',
  textileDyeSales: 'فروش رنگ نساجی',
  saddlery: 'سراجی',
  weaving: 'بافندگی',
  watchRepair: 'تعمیر ساعت',
  embroidery: 'گلدوزی',
  dryCleaning: 'خشکشویی',
  clothingAndJewelryProduction: 'تولید پوشاک و زیورآلات',
  womensChadorSewingAndSales: 'دوخت و فروش چادر زنانه',
  watchmaking: 'ساعت سازی',
  womensClothingProductionAndDistribution: 'تولید و پخش لباس زنانه',
  mensClothingProductionAndDistribution: 'تولید و پخش لباس مردانه',
  childrensClothingProductionAndDistribution: 'تولید و پخش لباس بچه گانه',
  babySetProductionAndDistribution: 'تولید و پخش سیسمونی',
  sportswearAndEquipmentProductionAndDistribution:
    'تولید و پخش لوازم و پوشاک ورزشی',
  clothingProductionAndDistribution: 'تولید و پخش لباس',
  socksProductionAndDistribution: 'تولید و پخش جوراب',
  watchProduction: 'تولید ساعت',
  workAndSafetyClothingProduction: 'تولید لباس کار و ایمنی',
  militaryClothingProduction: 'تولید لباس نظامی',
  underwearProductionAndDistribution: 'تولید و پخش لباس زیر',
  fabricProduction: 'تولید پارچه',
  shoeProduction: 'تولید کفش',
  bagAndShoeProduction: 'تولید کیف و کفش',
  bagAndLuggageProduction: 'تولید کیف و چمدان',
  leatherAndSalamoorProductionAndSales: 'تولید و فروش چرم و سالامبور',
  medicalClothing: 'لباس پزشکی',
  shoeDistribution: 'پخش کفش',
  homeBuildingAndInstallations: 'خانه، ساختمان و تاسیسات',
  householdAndOfficeAppliancesSales: 'لوازم خانگی و اداری - فروش',
  householdAppliancesSales: 'فروش لوازم خانگی',
  mattressAndBed: 'تشک خواب و تخت خواب',
  mattressQuiltAndPillowSales: 'فروش تشک لحاف و بالش',
  potAndPanSales: 'فروش قابلمه',
  furnitureAndDecorSales: 'فروش مبلمان و دکوراسیون',
  kitchenSuppliesAndUtensilsSales: 'فروش لوازم و ظروف آشپزخانه',
  audioAndVideoEquipmentSales: 'فروش لوازم صوتی و تصویری',
  carpetAndRugSales: 'فروش فرش و قالی',
  curtainSaleAndInstallation: 'فروش و نصب پرده',
  officeFurnitureSales: 'فروش مبلمان اداری',
  householdAppliancesSparePartsSales: 'فروش قطعات یدکی لوازم خانگی',
  prefabricatedOfficeEquipment: 'تجهیزات پیش ساخته اداری',
  waterPurifierSalesAndRepair: 'فروش و تعمیر دستگاه تصفیه آب',
  householdAndOfficeAppliancesProduction: 'لوازم خانگی و اداری - تولید',
  householdAppliancesProduction: 'تولید لوازم خانگی',
  potAndPanProduction: 'تولید قابلمه',
  furnitureAndDecorProductionAndDistribution: 'تولید و پخش مبلمان و دکوراسیون',
  kitchenwareProduction: 'تولید لوازم آشپزخانه',
  officeEquipmentProductionAndSales: 'تولید و فروش تجهیزات اداری',
  carpetAndRugProduction: 'تولید فرش و قالی',
  crystalAndCrystalWareProduction: 'تولید بلور و کریستال',
  mirrorAndCandlestickProductionAndDistribution: 'تولید و پخش آینه و شمعدان',
  gasStoveProduction: 'تولید اجاق گاز',
  digitalScaleProduction: 'تولید ترازوی دیجیتالی',
  sewingMachineProduction: 'تولید چرخ خیاطی',
  washingMachineProduction: 'تولید لباسشویی',
  vacuumCleanerProduction: 'تولید جاروبرقی',
  meatGrinderProduction: 'تولید چرخ گوشت',
  householdRefrigeratorAndFreezerProduction: 'تولید یخچال و فریزر خانگی',
  gasPoweredHouseholdAppliancesProduction: 'تولید لوازم خانگی گازسوز',
  chandelierAndLampProductionAndDistribution: 'تولید و پخش لوستر و آباژور',
  televisionProduction: 'تولید تلویزیون',
  audioAndVideoEquipmentProduction: 'تولید لوازم صوتی و تصویری',
  samovarMaking: 'سماور سازی',
  freestandingAndBuiltInGasStoveProduction: 'تولید اجاق گاز رومیزی و توکار',
  constructionAndDevelopment: 'ساخت و ساز',
  realEstateConsultant: 'مشاور املاک',
  greenhouseStructure: 'سازه گلخانه ای',
  falseFloorProductionAndImplementation: 'تولید و اجرا کف کاذب',
  steelDeckCeilingSales: 'فروش سقف عرشه فولادی',
  villaConstruction: 'ویلاسازی',
  acousticDoor: 'درب آکوستیک',
  lightWeightBlock: 'بلوک سبک',
  foamConcrete: 'فوم بتن',
  pvcCeilingTileProductionAndImplementation: 'تولید و اجرا سقف تایل pvc',
  buildingDesignAndArchitecture: 'طراحی و معماری ساختمان',
  buildingMaterials: 'مصالح ساختمان',
  permitIssuance: 'صدور پروانه',
  interiorArchitecture: 'معماری داخلی ساختمان',
  constructionCompany: 'شرکت ساختمانی',
  buildingAutomation: 'اتوماسیون ساختمان',
  smartBuilding: 'هوشمند سازی ساختمان',
  buildingRenovationAndRestoration: 'بازسازی و نوسازی ساختمان',
  concrete: 'بتن',
  scaffolding: 'داربست',
  buildingPainting: 'نقاشی ساختمان',
  portableCabinContainerAndCaravan: 'کانکس کانتینر و کاروان',
  excavation: 'خاکبرداری',
  landscaping: 'احداث فضای سبز',
  townshipDevelopment: 'شهرک سازی',
  constructionChemicals: 'مواد شیمیایی ساختمانی',
  acousticFalseCeiling: 'سقف کاذب آکوستیک',
  windowDisplayDecoration: 'تزیین ویترین',
  thermalAndRefrigerationInsulation: 'عایق حرارتی و برودتی',
  moistureInsulation: 'عایق رطوبتی',
  lightWeightStructuralSystem: 'سازه سبک ساختمانی',
  structuralStrengthening: 'مقاوم سازی سازه',
  constructionAndIndustrialPaintSales: 'فروش رنگ ساختمانی و صنعتی',
  studProduction: 'تولید گل میخ',
  studSales: 'فروش گل میخ',
  carpentry: 'نجاری',
  exhibitionHallDesignAndImplementation: 'طراحی و اجرای سالن نمایش',
  framing: 'قاب سازی',
  grinding: 'سنگ زنی',
  spaceFrameDesignAndProduction: 'طراحی و تولید سازه فضاکار',
  louveredWall: 'دیوار کرکره ای',
  prefabricatedBuildingComponents: 'قطعات پیش ساخته ساختمان',
  parkingSafetyEquipmentAndSupplies: 'تجهیزات و لوازم ایمنی پارکینگ',
  roofGardenDesignAndImplementation: 'طراحی و اجرای روف گاردن',
  buildingFacilities: 'تاسیسات ساختمان',
  cctvEquipmentProduction: 'تولید تجهیزات مداربسته',
  burglarAlarmAndAntiTheftSystemProduction: 'تولید دزدگیر و ضد سرقت',
  identificationAndSecurityEquipmentSales: 'فروش تجهیزات شناسایی و امنیتی',
  cctvEquipmentSaleAndInstallation: 'فروش و نصب تجهیزات مداربسته',
  firefightingEquipmentProduction: 'تولید تجهیزات آتش نشانی',
  fireExtinguisher: 'کپسول آتش نشانی',
  firefightingEquipmentSales: 'فروش تجهیزات آتش نشانی',
  fireAlarmAndSuppressionSystemSales: 'فروش سیستم اعلام و اطفا حریق',
  burglarAlarmAndAntiTheftSystemSales: 'فروش دزدگیر و ضد سرقت',
  electronicSecurityAndProtectionSystemProduction:
    'تولید سیستم امنیتی و حفاظت الکترونیکی',
  electronicSecurityAndProtectionSystemSales:
    'فروش سیستم امنیتی و حفاظت الکترونیکی',
  hoseProduction: 'تولید شیلنگ',
  electricalPanelEquipmentProduction: 'تولید تجهیزات تابلو برق',
  securityAndProtectionSystem: 'سیستم امنیتی و حفاظتی',
  coolingSystems: 'تاسیسات سرمایشی',
  facilitiesAndEquipmentContractor: 'پیمانکار تاسیسات و تجهیزات',
  buildingFacilitiesEquipment: 'تجهیزات تاسیسات ساختمان',
  coldStorage: 'سردخانه',
  mechanicalBuildingFacilities: 'تاسیسات مکانیکی ساختمان',
  wireAndCable: 'سیم و کابل',
  heatingSystems: 'تاسیسات گرمایشی',
  lightingEquipment: 'تجهیزات نورپردازی و روشنایی',
  pipesAndFittings: 'لوله و اتصالات',
  electricalAndSecurityBuildingFacilities: 'تاسیسات الکتریکی و امنیتی ساختمان',
  multistageCentrifugalPump: 'پمپ سانتریفیوژ طبقاتی',
  industrialFacilities: 'تاسیسات صنعتی',
  videoIntercom: 'آیفون تصویری',
  meter: 'کنتور',
  antenna: 'آنتن',
  industrialOrBuildingElectricalWiring: 'سیم کشی برق صنعتی یا ساختمانی',
  electricalFacilities: 'تاسیسات برق',
  elevatorSales: 'فروش آسانسور',
  escalatorProduction: 'تولید پله برقی',
  escalatorEquipment: 'تجهیزات پله برقی',
  escalatorSaleInstallationAndRepair: 'فروش و نصب و تعمیر پله برقی',
  urbanFacilities: 'تاسیسات شهری',
  garbageChute: 'شوتینگ زباله',
  poolSaunaAndJacuzziEquipment: 'تجهیزات استخر سونا و جکوزی',
  patioFountainAndWaterfall: 'آبنما پاسیو و آبشار',
  industrialInsulation: 'ایزولاسیون صنعتی',
  waterAndWastewaterTreatment: 'تصفیه آب و فاضلاب',
  buildingEquipmentAndDecor: 'تجهیزات و دکوراسیون ساختمان',
  buildingDecor: 'دکوراسیون ساختمان',
  hotelEquipment: 'تجهیزات هتلی',
  vanityCabinetProductionAndSales: 'تولید و فروش کابینت روشویی',
  doorsAndWindows: 'درب و پنجره',
  tileAndCeramic: 'کاشی و سرامیک',
  faucetsAndFittings: 'شیرآلات و اتصالات',
  flooringAndParquet: 'کفپوش و پارکت',
  buildingSanitarySupplies: 'لوازم بهداشتی ساختمان',
  wallpaper: 'کاغذ دیواری',
  glassAndMirror: 'شیشه و آینه',
  buildingAndDecorativeStone: 'سنگ ساختمانی و تزیینی',
  roofAndBuildingFacade: 'سقف و نمای ساختمان',
  carpetSaleAndInstallation: 'فروش و نصب موکت',
  fireplace: 'شومینه',
  partition: 'پارتیشن',
  iraniteAndShirvani: 'ایرانیت و شیروانی',
  boxAndShelf: 'باکس و شلف',
  lockAndHandle: 'قفل و دستگیره',
  cabinetProductionAndSales: 'تولید و فروش کابینت',
  cinemaHallEquipment: 'تجهیزات سالن سینما',
  tentAndCanopy: 'خیمه و سایبان',
  shelving: 'قفسه بندی',
  lath: 'رابیتس',
  decorativeSticker: 'برچسب دکوراتیو',
  plasterStuccoWork: 'گچبری',
  wallCovering: 'دیوارپوش',
  carpetProduction: 'تولید موکت',
  roofTileSales: 'فروش سفال بام',
  homeAndBuildingServices: 'خدمات خانه و ساختمان',
  carpetCleaning: 'قالیشویی',
  constructionServices: 'خدمات ساختمانی',
  glassDoorRepair: 'تعمیر درب شیشه ای',
  dishwasherRepair: 'تعمیر ظرفشویی',
  automaticDoorRepair: 'تعمیر درب اتوماتیک',
  sofaDryCleaning: 'خشکشویی مبل',
  afterSalesServiceAndRepairOfHouseholdAppliances:
    'تعمیر و خدمات پس از فروش لوازم خانگی',
  homeAndOfficeFurnitureRepair: 'تعمیر مبلمان خانگی و اداری',
  officeFurnitureAndChairRepair: 'تعمیر مبلمان و صندلی اداری',
  plumbing: 'لوله کشی',
  carpetAndRugServices: 'خدمات فرش و قالی',
  utilitiesServices: 'خدمات تاسیسات',
  drainCleaningAndWellEmptying: 'لوله بازکنی و تخلیه چاه',
  publicAndGovernmentalServices: 'خدمات عمومی و دولتی',
  publicServices: 'خدمات عمومی',
  police10: 'پلیس 10',
  lawOffice: 'موسسه حقوقی',
  communicationServicesOffice: 'دفتر خدمات ارتباطی',
  cityElectronicServicesOffice: 'دفتر خدمات الکترونیک شهر',
  notaryOffice: 'دفتر اسناد رسمی',
  governmentCitizenServiceOffice: 'دفتر پیشخوان دولت',
  companyRegistration: 'ثبت شرکت',
  lawyer: 'وکیل',
  translationOffice: 'دارالترجمه',
  disputeResolutionCouncil: 'شورای حل اختلاف',
  civilRegistrationOffice: 'دفتر ثبت احوال',
  marriageAndDivorceRegistrationOffice: 'دفتر ثبت ازدواج و طلاق',
  airlineAgencyLicenseRegistration: 'ثبت مجوز آژانس هواپیمایی',
  deedsAndRealEstateRegistrationOffice: 'اداره ثبت اسناد و املاک',
  database: 'بانک اطلاعاتی',
  gasEmergency: 'امداد گاز',
  privateDetectiveAgency: 'کارآگاه خصوصی',
  publicWarehouse: 'انبار عمومی',
  serviceCompany: 'شرکت خدماتی',
  sourceOfEmulationOffice: 'دفتر مرجع تقلید',
  fireEmergency: 'امداد آتش نشانی',
  waterEmergency: 'امداد آب',
  cityLandmarks: 'عناصر شاخص شهر',
  stampSales: 'تمبر فروشی',
  metalShelfEquipment: 'تجهیزات قفسه فلزی',
  flowerShop: 'گل فروشی',
  birdShop: 'پرنده فروشی',
  keyMaking: 'کلید سازی',
  publicBathhouse: 'حمام عمومی',
  charitableFoundation: 'موسسه خیریه',
  conscriptionOrganization: 'سازمان وظیفه عمومی',
  policeStationAndOutpost: 'کلانتری و پاسگاه نیروی انتظامی',
  criminalInvestigationPolice: 'پلیس آگاهی',
  prosecutorOfficeAndPublicCourt: 'دادسرا و دادگاه عمومی',
  courtAndJudicialComplex: 'دادگاه و مجتمع قضایی',
  prison: 'زندان',
  lawEnforcementCenter: 'مرکز انتظام',
  policeDepartmentsAndAgencies: 'ادارات و سازمان های ناجا',
  airportPolice: 'پلیس فرودگاه',
  railwayPolice: 'پلیس راه آهن',
  forestAndRangelandProtectionUnit: 'یگان حفاظت از جنگل و مراتع',
  prisonProtectionUnit: 'یگان حفاظت از زندان ها',
  culturalHeritageProtectionUnit: 'یگان حفاظت از میراث فرهنگی',
  environmentalProtectionUnit: 'یگان حفاظت از محیط زیست',
  governmentOffices: 'ادارات دولتی',
  organizationsAndGovernmentOffices: 'سازمان ها و ادارات دولتی',
  medicalCouncilOrganization: 'سازمان نظام پزشکی',
  consulate: 'کنسولگری',
  retirees: 'بازنشستگان',
  unionAssociationCooperative: 'اتحادیه، انجمن، تعاونی',
  trafficDepartment: 'اداره راهنمایی و رانندگی',
  educationDistricts: 'مناطق آموزش و پرورش',
  internationalOrganization: 'سازمان بین المللی',
  municipalDepartmentsAndOrganizations: 'ادارات و سازمان های شهرداری',
  municipalDistrictsAndAreas: 'مناطق و نواحی شهرداری',
  institutionsOrganizationsAndBodiesAffiliatedWithTheLeadership:
    'نهادها سازمان ها و موسسات تابعه رهبری',
  institutionsOrganizationsAndBodiesAffiliatedWithTheLegislature:
    'نهادها، سازمان ها و موسسات تابعه قوه مقننه',
  institutionsOrganizationsAndBodiesAffiliatedWithThePresidency:
    'نهادها و سازمان ها و موسسات تابعه ریاست جمهوری',
  institutionsOrganizationsAndBodiesAffiliatedWithTheJudiciary:
    'نهادها، سازمان ها و موسسات تابعه قوه قضاییه',
  judicialElectronicServicesOffice: 'دفتر خدمات الکترونیک قضایی',
  leadership: 'رهبری',
  nonGovernmentalOrganization: 'سازمان غیر دولتی',
  embassy: 'سفارتخانه',
  postalDistricts: 'مناطق پستی',
  electricityDistricts: 'مناطق برق',
  telecommunicationDistrict: 'منطقه مخابراتی',
  reliefCommittee: 'کمیته امداد',
  broadcastingNetwork: 'شبکه صدا',
  countyRadioAndTelevision: 'صدا و سیمای شهرستان ها',
  radioAndTelevisionDepartmentsAndOrganizations:
    'ادارات و سازمان های صدا و سیما',
  radioAndTelevisionTelevisionNetwork: 'شبکه تلویزیونی صدا و سیما',
  presidency: 'ریاست جمهوری',
  basijCenter: 'مرکز بسیج',
  militaryBarracks: 'پادگان نظامی',
  sportsFederation: 'فدراسیون ورزشی',
  ministries: 'وزارتخانه ها',
  ministryOfEducation: 'وزارت آموزش و پرورش',
  ministryOfHealthTreatmentAndMedicalEducation:
    'وزارت بهداشت، درمان و آموزش پزشکی',
  ministryOfForeignAffairs: 'وزارت امور خارجه',
  ministryOfRoadAndUrbanDevelopment: 'وزارت راه و شهرسازی',
  ministryOfScienceResearchAndTechnology: 'وزارت علوم، تحقیقات و فن آوری',
  ministryOfAgriculturalJihad: 'وزارت جهاد کشاورزی',
  ministryOfInformationAndCommunicationsTechnology:
    'وزارت ارتباطات و فن آوری اطلاعات',
  ministryOfIntelligence: 'وزارت اطلاعات',
  ministryOfEconomicAffairsAndFinance: 'وزارت امور اقتصادی و دارایی',
  ministryOfJustice: 'وزارت دادگستری',
  ministryOfDefenseAndArmedForcesSupport: 'وزارت دفاع و پشتیبانی نیروهای مسلح',
  ministryOfIndustryMineAndTrade: 'وزارت صنعت، معدن و تجارت',
  ministryOfCultureAndIslamicGuidance: 'وزارت فرهنگ و ارشاد اسلامی',
  ministryOfInterior: 'وزارت کشور',
  ministryOfOil: 'وزارت نفت',
  ministryOfEnergy: 'وزارت نیرو',
  ministryOfSportsAndYouth: 'وزارت ورزش و جوانان',
  ministryOfCooperativesLabourAndSocialWelfare:
    'وزارت تعاون، کار و رفاه اجتماعی',
  ministryOfCulturalHeritageTourismAndHandicrafts:
    'وزارت میراث فرهنگی، گردشگری و صنایع دستی',
  protocolAndCeremonies: 'تشریفات و مجالس',
  ceremonyAndEventServices: 'خدمات مجالس و مراسم',
  aerialImagingHelicopterShot: 'تصویربرداری هوایی (هلی شات)',
  seminarOrganizationServices: 'خدمات برگزاری سمینار',
  receptionHall: 'تالار پذیرایی',
  photographyAndFilming: 'عکاسی و فیلمبرداری',
  photoStudio: 'آتلیه عکاسی',
  weddingInvitationCard: 'کارت عروسی',
  birthdayDecoration: 'تم تولد',
  securityAndSurveillanceInstitute: 'موسسه حفاظتی و مراقبتی',
  financialAndBankingServices: 'خدمات مالی و بانکداری',
  mobileCardReaderDevice: 'دستگاه کارتخوان سیار',
  coinTrading: 'خرید و فروش سکه',
  bank: 'بانک',
  atm: 'دستگاه خودپرداز',
  qardAlHasanahBank: 'بانک قرض الحسنه',
  foreignBank: 'بانک خارجی',
  financialAndCreditInstitution: 'موسسه مالی و اعتباری',
  currencyExchange: 'صرافی',
  qardAlHasanahFund: 'صندوق قرض الحسنه',
  shoppingCenters: 'مراکز خرید',
  passageAndCommercialComplex: 'پاساژ و مجتمع تجاری',
  chainStore: 'فروشگاه زنجیره ای',
  consumerCooperativeStore: 'فروشگاه تعاونی مصرف',
  fruitAndVegetableMarket: 'بازار و میدان میوه و تره بار',
  occupationalRow: 'راسته شغلی',
  tobaccoProducts: 'دخانیات',
  tobaccoProduction: 'تولید تنباکو',
  hookahSales: 'فروش قلیان',
  cigaretteSales: 'فروش سیگار',
  matchProductionAndDistribution: 'تولید و پخش کبریت',
  charcoalSales: 'فروش ذغال چوب',
  restaurantAndFood: 'رستوران و غذا',
  restaurantAndSnackBar: 'رستوران و اغذیه فروشی',
  restaurant: 'رستوران',
  pizzaAndSandwich: 'پیتزا و ساندویچ',
  fastFood: 'فست فود',
  chelowKabab: 'چلوکبابی',
  kebabAndLiverShop: 'کبابی و جگرکی',
  foreignCuisineRestaurant: 'رستوران غذاهای خارجی',
  vegetarianRestaurant: 'رستوران گیاهی',
  traditionalDiningHall: 'سفره خانه سنتی',
  coffeeShop: 'کافی شاپ',
  mealPreparation: 'تهیه غذا',
  cooking: 'طباخی',
  halimAndAshPreparation: 'حلیم پزی و آش',
  traditionalCoffeeHouse: 'قهوه خانه سنتی',
  coffeeHouseAndDiziSara: 'قهوه خانه و دیزی سرا',
  foodSales: 'فروش مواد غذایی',
  foodRawMaterialsSales: 'فروش مواد اولیه غذایی',
  sausageAndColdCutsAndProteinMeatProductsSales:
    'فروش سوسیس و کالباس و فرآورده گوشتی پروتئینی',
  teaAndHerbalInfusionSales: 'فروش چای و دمنوش',
  teaSales: 'فروش چای',
  fruitLeatherSales: 'فروش لواشک',
  cheeseSales: 'فروش پنیر',
  kashkSales: 'فروش کشک',
  sohanAndGazSales: 'فروش سوهان و گز',
  biscuitSales: 'فروش بیسکویت',
  cakeAndCookieSales: 'فروش کیک و کلوچه',
  dateSales: 'فروش خرما',
  honeySales: 'فروش عسل',
  saffronSales: 'فروش زعفران',
  riceSales: 'فروش برنج',
  legumeSales: 'فروش حبوبات',
  cocoaPowderSales: 'فروش پودر کاکائو',
  confectioneryAndPastryRawMaterialsSales: 'فروش مواد اولیه قنادی و شیرینی پزی',
  driedFruitAndFruitChipsSales: 'فروش میوه خشک و چیپس میوه',
  starchSales: 'فروش نشاسته',
  yeastSales: 'فروش خمیر مایه',
  oilseedSales: 'فروش دانه روغنی',
  butterSales: 'فروش کره',
  oliveOilSales: 'فروش روغن زیتون',
  frozenFoodSales: 'فروش مواد غذایی منجمد',
  spiceSales: 'فروش ادویه',
  picklesSales: 'فروش ترشیجات',
  raisin: 'کشمش',
  seeds: 'تخمه',
  groceryStore: 'خواربار فروشی',
  meatAndMeatProductsSales: 'فروش گوشت و فرآورده های گوشتی',
  snacks: 'تنقلات',
  wholesaleFoodSales: 'فروش عمده مواد غذایی',
  fruitAndVegetableSales: 'فروش میوه و تره بار',
  juiceAndIceCreamSales: 'فروش آبمیوه و بستنی',
  nutAndDriedFruitSales: 'فروش آجیل و خشکبار',
  pistachioSales: 'فروش پسته',
  supermarket: 'سوپر مارکت',
  bakery: 'نانوایی',
  butchery: 'قصابی',
  poultryShop: 'مرغ فروشی',
  fishAndShrimpSales: 'فروش ماهی و میگو',
  confectionery: 'قنادی',
  rockCandySales: 'فروش نبات',
  foodServices: 'خدمات مواد غذایی',
  iceCreamDistribution: 'پخش بستنی',
  dairyDistribution: 'پخش لبنیات',
  foodRawMaterialsDistribution: 'پخش مواد اولیه غذایی',
  softDrinkDistribution: 'پخش نوشابه',
  eggDistribution: 'پخش تخم مرغ',
  mineralWaterDistribution: 'پخش آب معدنی',
  vegetableOilDistribution: 'پخش روغن نباتی',
  tomatoPasteDistribution: 'پخش رب گوجه فرنگی',
  beverageServices: 'خدمات نوشیدنی',
  foodDistribution: 'پخش مواد غذایی',
  proteinMaterialsDistribution: 'پخش مواد پروتئینی',
  foodPackaging: 'بسته بندی مواد غذایی',
  driedFruitPackaging: 'بسته بندی خشکبار',
  legumesPackaging: 'بسته بندی حبوبات',
  scaleAndBalanceRepair: 'تعمیر باسکول و ترازو',
  sausageSlicerRepair: 'تعمیر کالباس بر',
  fastFoodRawMaterialsDistribution: 'پخش مواد اولیه فست فود',
  teaDistribution: 'پخش چای',
  foodProduction: 'تولید مواد غذایی',
  teaAndHerbalInfusionProduction: 'تولید چای و دمنوش',
  coffeeAndNescafeProduction: 'تولید قهوه و نسکافه',
  honeyProduction: 'تولید عسل',
  caviarProduction: 'تولید خاویار',
  cottonCandyProduction: 'تولید پشمک',
  organicFoodMaterialAndProductProduction: 'تولید مواد و محصولات غذایی ارگانیک',
  oilseedProduction: 'تولید دانه روغنی',
  mushroomProduction: 'تولید قارچ',
  saltProduction: 'تولید نمک',
  oliveOilProduction: 'تولید روغن زیتون',
  vegetableOilProduction: 'تولید روغن نباتی',
  cannedFoodProduction: 'تولید کنسرو',
  chipsProduction: 'تولید چیپس',
  jamProduction: 'تولید مربا',
  fruitJuiceProduction: 'تولید آبمیوه',
  milkProduction: 'تولید شیر',
  butterProduction: 'تولید کره',
  dairyProduction: 'تولید لبنیات',
  flourProduction: 'تولید آرد',
  starchProduction: 'تولید نشاسته',
  sugarAndLumpSugarProduction: 'تولید قند و شکر',
  gumProduction: 'تولید آدامس',
  halvaProduction: 'تولید حلوا',
  sohanMaking: 'سوهان پزی',
  chocolateAndCandyProduction: 'تولید شکلات و آب نبات',
  pastaProduction: 'تولید ماکارونی',
  teaProduction: 'تولید چای',
  yeastProduction: 'تولید خمیر مایه',
  babyFoodProduction: 'تولید غذای کودک',
  tomatoPasteProduction: 'تولید رب گوجه فرنگی',
  samanuMaking: 'سمنو پزی',
  iceProduction: 'تولید یخ',
  softDrinkProduction: 'تولید نوشابه',
  mineralWaterProduction: 'تولید آب معدنی',
  rosewaterProduction: 'تولید گلاب',
  cerealProduction: 'تولید غلات',
  wheatProduction: 'تولید گندم',
  soybeanProduction: 'تولید سویا',
  eggProduction: 'تولید تخم مرغ',
  vegetableChoppingAndLemonJuiceAndVerjuiceExtraction:
    'سبزی خردکنی و آبلیمو و آبغوره گیری',
  spiceProduction: 'تولید ادویه',
  picklesProduction: 'تولید ترشیجات',
  condimentProduction: 'تولید چاشنیجات',
  foodIndustry: 'صنعت غذایی',
  restaurantConsultingAndSetup: 'مشاوره و راه اندازی رستوران',
  foodRawMaterialsImportExport: 'واردات و صادرات مواد اولیه غذایی',
  softDrinkCupProduction: 'تولید تشتک نوشابه',
  confectioneryAndPastryEquipmentProduction: 'تولید لوازم قنادی و شیرینی پزی',
  industrialKitchenEquipmentSales: 'فروش تجهیزات آشپزخانه صنعتی',
  sausageSlicerSales: 'فروش کالباس بر',
  coffeeShopSuppliesAndEquipmentProduction: 'تولید لوازم و تجهیزات کافی شاپ',
  coffeeShopSetup: 'راه اندازی کافی شاپ',
  foodIndustryConsultant: 'مشاور صنایع غذایی',
  foodQualityControl: 'کنترل کیفیت مواد غذایی',
  coffeeShopSuppliesAndEquipmentSales: 'فروش لوازم و تجهیزات کافی شاپ',
  digitalScaleSales: 'فروش ترازوی دیجیتالی',
  scaleOperation: 'باسکول داری',
  industrialMixerProduction: 'تولید همزن صنعتی',
  industrialKitchenEquipmentProduction: 'تولید تجهیزات آشپزخانه صنعتی',
  digitalScaleRepair: 'تعمیر ترازوی دیجیتالی',
  scaleAndBalanceProduction: 'تولید باسکول و ترازو',
  iceCreamMaker: 'بستنی ساز',
  handTrolleyProduction: 'تولید چرخ دستی',
  confectioneryAndPastrySuppliesSales: 'فروش لوازم قنادی و شیرینی پزی',
  industry: 'صنعت',
  designAndProductionIndustries: 'صنایع - طراحی و تولید',
  aerospaceIndustry: 'صنایع هواپیمایی',
  laserEngraving: 'حکاکی لیزر',
  industrialSalt: 'نمک صنعتی',
  stuffingProduction: 'تولید پوشال',
  drillingEquipmentAndSuppliesProduction: 'تولید تجهیزات و لوازم حفاری',
  plasticNetProduction: 'تولید توری پلاستیکی',
  nylonAndNylonxProduction: 'تولید نایلون و نایلکسن',
  stationeryProduction: 'تولید لوازم التحریر',
  crystalMaking: 'بلور سازی',
  industrialFilterProduction: 'تولید فیلتر صنعتی',
  industrialMoldMaking: 'قالب سازی صنعتی',
  rubberProductsProduction: 'تولید محصولات لاستیکی',
  plasticProductsProduction: 'تولید مصنوعات پلاستیک',
  industrialFurnaceProduction: 'تولید کوره صنعتی',
  woodAndMetalIndustries: 'صنایع چوب و فلز',
  paintCuringOvenProduction: 'تولید کوره پخت رنگ',
  hotAirOvenProduction: 'تولید کوره هوای گرم',
  woodIndustryProductionAndSales: 'تولید و فروش صنایع چوبی',
  industrialRefrigeratorAndFreezerProduction: 'تولید یخچال و فریزر صنعتی',
  industrialThermocoupleSales: 'فروش ترموکوپل صنعتی',
  medicalSportsEquipmentProduction: 'تولید لوازم ورزشی پزشکی',
  industrialDesign: 'طراحی صنعتی',
  industrialAutomation: 'اتوماسیون صنعتی',
  furnitureAndOfficeChairProduction: 'تولید مبلمان و صندلی اداری',
  industrialModelMaking: 'ماکت سازی صنعتی',
  industrialPartsDesignAndProduction: 'طراحی و تولید قطعات صنعتی',
  plasticMoldMaking: 'قالب سازی پلاستیک',
  injectionPlasticMaking: 'پلاستیک سازی تزریقی',
  carTireProduction: 'تولید لاستیک خودرو',
  asphaltProduction: 'تولید آسفالت',
  spongeAndFoamProduction: 'تولید اسفنج و فوم',
  spongeAndCloudProduction: 'تولید اسفنج و ابر',
  wasteRecycling: 'بازیافت ضایعات',
  mineContractor: 'پیمانکار معدن',
  drillingAndExtraction: 'حفاری و استخراج',
  tankProduction: 'تولید مخازن',
  industrialRadiography: 'رادیوگرافی صنعتی',
  industrialChainProduction: 'تولید زنجیر صنعتی',
  industrialBrush: 'برس صنعتی',
  mineralMaterialsProduction: 'تولید مواد معدنی',
  tankerManufacturing: 'تانکر سازی',
  ovenPainting: 'رنگ کاری کوره ای',
  factoryEquipmentProductionAndInstallation:
    'تولید و راه اندازی تجهیزات کارخانه',
  bearingAndOilSealProduction: 'تولید بلبرینگ و کاسه نمد',
  dryIce: 'یخ خشک',
  fileFolderProduction: 'تولید زونکن',
  heatingElementAndThermalSuppliesProduction: 'تولید المنت و لوازم حرارتی',
  chemicalRawMaterialsProduction: 'تولید مواد اولیه شیمیایی',
  industrialCharcoalProduction: 'تولید ذغال صنعتی',
  coalProduction: 'تولید ذغال سنگ',
  miningEquipmentProduction: 'تولید تجهیزات معدن',
  plasticRawMaterialsProduction: 'تولید مواد اولیه پلاستیک',
  industrialAdhesiveAndResinProduction: 'تولید چسب و رزین صنعتی',
  castingRawMaterialsProduction: 'تولید مواد اولیه ریخته گری',
  polypropyleneSackProduction: 'تولید گونی پلی پروپیلن',
  rulerProduction: 'تولید خط کش',
  penProduction: 'تولید خودکار',
  inventor: 'مخترع',
  oilAndGasTankProduction: 'تولید مخازن نفت و گاز',
  siloConstruction: 'سیلو سازی',
  paintAndResinProduction: 'تولید رنگ و رزین',
  textileChemicalsProduction: 'تولید مواد شیمیایی نساجی',
  industrialAdhesiveProduction: 'تولید چسب صنعتی',
  paintAndChemicalsProduction: 'تولید رنگ و مواد شیمیایی',
  powderPaintProduction: 'تولید رنگ پودری',
  distilledWaterProduction: 'تولید آب مقطر',
  mineralAndIndustrialPowderProduction: 'تولید پودر معدنی و صنعتی',
  adhesiveProduction: 'تولید چسب',
  refractoryMaterialsAndPartsProduction: 'تولید مواد و قطعات نسوز',
  nanotechnology: 'نانو تکنولوژی',
  plasticBottleCapProduction: 'تولید درب پلاستیکی بطری',
  nylonAndNylexProduction: 'تولید نایلون و نایلکس',
  plasticProduction: 'تولید پلاستیک',
  plasticMatProduction: 'تولید حصیر پلاستیکی',
  industrialPlasticProduction: 'تولید پلاستیک صنعتی',
  plasticBottleProduction: 'تولید بطری پلاستیکی',
  fabricWaste: 'ضایعات پارچه',
  metalWaste: 'ضایعات فلزات',
  aluminumWaste: 'ضایعات آلومینیوم',
  scrapDealer: 'اوراقی فروشی',
  textileWaste: 'ضایعات نساجی',
  ironWaste: 'ضایعات آهن',
  plasticWaste: 'ضایعات پلاستیک',
  paperWaste: 'ضایعات کاغذ',
  drilling: 'حفاری',
  rubberStripProduction: 'تولید نوار لاستیکی',
  pvcTape: 'نوار پی وی سی',
  industrialFiber: 'فیبر صنعتی',
  salesAndRepairIndustries: 'صنایع - فروش و تعمیرات',
  industrialOil: 'روغن صنعتی',
  ironOre: 'سنگ آهن',
  tankSales: 'فروش مخازن',
  pharmaceuticalRawMaterialsSales: 'فروش مواد اولیه دارو',
  scaleAndBalanceSales: 'فروش باسکول و ترازو',
  tankRepair: 'تعمیر مخازن',
  marineAndShipPartsAndSuppliesSales: 'فروش قطعات و لوازم شناور و کشتی',
  paintAndResinSales: 'فروش رنگ و رزین',
  displayRefrigeratorSales: 'فروش یخچال ویترینی',
  industrialBearingAndBallBearingSales: 'فروش یاتاقان و بلبرینگ صنعتی',
  tankerSales: 'فروش تانکر',
  industrialAdhesiveSales: 'فروش چسب صنعتی',
  fiberglassRawMaterialsSales: 'فروش مواد اولیه فایبرگلاس',
  powderPaintSales: 'فروش رنگ پودری',
  mineralAndIndustrialPowderSales: 'فروش پودر معدنی و صنعتی',
  refractoryMaterialsAndPartsSales: 'فروش مواد و قطعات نسوز',
  plasticBottleSales: 'فروش بطری پلاستیکی',
  drillingEquipmentAndSuppliesSales: 'فروش تجهیزات و لوازم حفاری',
  industrialBrushSales: 'فروش برس صنعتی',
  drillingMachinerySales: 'فروش ماشین آلات حفاری',
  cncCutting: 'برشکاری CNC',
  waxAndPolishSales: 'فروش واکس و پولیش',
  plasticAndPolypropyleneBagSales: 'فروش کیسه پلاستیکی و پلی پروپیلن',
  bubblePlasticSales: 'فروش پلاستیک حباب دار',
  mineralPumiceSales: 'فروش پوکه معدنی',
  laboratoryMaterialsSales: 'فروش مواد آزمایشگاهی',
  chemicalSubstances: 'مواد شیمیایی',
  industrialFilterSales: 'فروش فیلتر صنعتی',
  chemicalRawMaterialsSales: 'فروش مواد اولیه شیمیایی',
  plasticProductsSales: 'فروش مصنوعات پلاستیک',
  coldStorageRental: 'اجاره سردخانه',
  inductionFurnaceProduction: 'تولید کوره القایی',
  industrialRefrigeratorAndFreezerRepair: 'تعمیر یخچال و فریزر صنعتی',
  industrialRefrigeratorAndFreezerSales: 'فروش یخچال و فریزر صنعتی',
  industrialChainSales: 'فروش زنجیر صنعتی',
  adhesiveSales: 'فروش چسب',
  industrialCharcoalSales: 'فروش ذغال صنعتی',
  coalSales: 'فروش ذغال سنگ',
  rubberCutting: 'برشکاری لاستیک',
  miningEquipmentSales: 'فروش تجهیزات معدن',
  bearingAndOilSealSales: 'فروش بلبرینگ و کاسه نمد',
  chemicalSubstancesSales: 'فروش مواد شیمیایی',
  spongeAndFoamSales: 'فروش اسفنج و فوم',
  carWashMachineAndEquipmentSales: 'فروش دستگاه و تجهیزات کارواش',
  packagingIndustry: 'صنعت بسته بندی',
  polystyrenePackaging: 'بسته بندی با یونولیت',
  polystyrene: 'یونولیت',
  cardboardBoxProduction: 'تولید کارتن مقوایی',
  cardboardTube: 'لوله مقوایی',
  cardboardBoxSales: 'فروش کارتن مقوایی',
  packagingServices: 'خدمات بسته بندی',
  cardboardBoxesSales: 'فروش جعبه مقوایی',
  cardboardBoxesProduction: 'تولید جعبه مقوایی',
  plasticCardboard: 'کارتن پلاست',
  shrinkWrapEquipment: 'تجهیزات شیرینگ پک',
  packagingSuppliesSales: 'فروش لوازم بسته بندی',
  packagingSuppliesProduction: 'تولید لوازم بسته بندی',
  fruitBox: 'جعبه میوه',
  metalBox: 'جعبه فلزی',
  plasticVacuum: 'وکیوم پلاستیکی',
  ropeAndTwine: 'طناب و ریسمان',
  adhesiveTape: 'نوار چسب',
  metalsIndustry: 'صنایع فلزات',
  ironSales: 'فروش آهن',
  steelAlloy: 'آلیاژ فولادی',
  industrialAndMetalSheet: 'ورق فلزی و صنعتی',
  metalProfile: 'پروفیل فلزات',
  nonMetallicMineral: 'کانی غیر فلزی',
  nonFerrousAlloy: 'آلیاژ غیر آهنی',
  ironProduction: 'تولید آهن',
  industrialRebar: 'میلگرد صنعتی',
  wireDrawing: 'کشش مفتول',
  aluminumProducts: 'مصنوعات آلومینیوم',
  aluminumIngot: 'شمش آلومینیوم',
  aluminumFoil: 'فویل آلومینیوم',
  castPartsProduction: 'تولید قطعات ریخته گری',
  soldering: 'لحیم کاری',
  metalWire: 'سیم فلزی',
  metalBarrel: 'بشکه فلزی',
  metalRod: 'مفتول فلزی',
  metalIndustries: 'صنایع فلزی',
  copperSales: 'فروش مس',
  bronze: 'برنز',
  castIronIngot: 'شمش چدن',
  zincIngot: 'شمش روی',
  metalSheet: 'ورق فلزی',
  steelParts: 'قطعات فولادی',
  copperWire: 'مفتول مسی',
  nonFerrousMetals: 'فلزات غیر آهنی',
  powderParts: 'قطعات پودری',
  metalMesh: 'توری فلزی',
  metalCan: 'قوطی فلزی',
  steelMesh: 'توری استیل',
  moldings: 'قالکاری',
  plasticSheetAndPipe: 'ورق و لوله پلاستیکی',
  rubberSheet: 'ورق لاستیکی',
  steelSheet: 'ورق استیل',
  pvcPlasticSheet: 'ورق پلاستیک پی وی سی',
  polymerSheet: 'ورق پلیمر',
  aluminumSheet: 'ورق آلومینیوم',
  ironProfile: 'پروفیل آهن',
  aluminumProfile: 'پروفیل آلومینیوم',
  wireRope: 'سیم بکسل',
  barbedWireAndMeshWire: 'سیم خاردار و سیم توری',
  copperRolling: 'نورد مس',
  leadProduction: 'تولید سرب',
  metalIndustryServices: 'خدمات صنایع فلزات',
  metalTurning: 'تراشکاری فلزات',
  metalBending: 'خمکاری فلزات',
  plasticPlating: 'آبکاری پلاستیک',
  metalGlazing: 'لعاب کاری فلزات',
  metalPlating: 'آبکاری فلزات',
  aluminumPlating: 'آبکاری آلومینیوم',
  platingEquipment: 'تجهیزات آبکاری',
  industrialPartsTurning: 'تراشکاری قطعات صنعتی',
  valveTurning: 'سوپاپ تراشی',
  turningAndMoldMaking: 'تراشکاری و قالب سازی',
  seriesTurning: 'سری تراشی',
  aluminumCasting: 'ریخته گری آلومینیوم',
  plasticWelding: 'جوش پلاستیک',
  mirrorAndCandlestickBending: 'خمکاری آینه و شمعدان',
  sheetCuttingAndBending: 'برشکاری و خمکاری ورق',
  ironAndSteelCutting: 'برشکاری آهن و فولاد',
  waterJet: 'واترجت',
  industrialBrushProduction: 'تولید برس صنعتی',
  hydraulicPress: 'پرس هیدرولیکی',
  milling: 'فرزکاری',
  finishing: 'پرداخت کاری',
  pressing: 'پرسکاری',
  bending: 'خمکاری',
  blacksmithing: 'آهنگری',
  plating: 'آبکاری',
  smeltingAndRolling: 'ذوب و نورد',
  hardening: 'سخت کاری',
  metalCasting: 'ریخته گری فلزات',
  weldTest: 'تست جوش',
  welding: 'جوشکاری',
  metalCutting: 'برشکاری فلزات',
  impactPress: 'پرس ضربه ای',
  goldMaking: 'طلا سازی',
  industrialForging: 'آهنگری صنعتی',
  goldAndJewelryDesign: 'طراحی طلا و جواهر',
  metalDetectorProductionAndSales: 'تولید و فروش دستگاه فلزیاب',
  engineeringAndTechnicalServices: 'خدمات فنی و مهندسی',
  technicalAndEngineeringServices: 'خدمات فنی مهندسی',
  blueprintProduction: 'تولید نقشه',
  trackingSystemAndGpsSales: 'فروش سیستم ردیابی و جی پی اس',
  surveyingEquipmentSales: 'فروش لوازم نقشه برداری',
  surveyingTheodolite: 'دوربین نقشه برداری',
  satelliteSurveying: 'نقشه برداری ماهواره ای',
  geology: 'زمین شناسی',
  geographicInformation: 'اطلاعات جغرافیایی',
  agriculturalConsultingEngineers: 'مهندسین مشاور کشاورزی',
  constructionConsultingEngineers: 'مهندسین مشاور ساختمان',
  facilityConsultingEngineers: 'مهندسین مشاور تاسیسات',
  consultingEngineers: 'مهندسین مشاور',
  mechanicalEngineering: 'مهندسی مکانیک',
  hydraulicAndPneumaticEngineering: 'مهندسی هیدرولیک و پنوماتیک',
  miningEngineering: 'مهندسی معدن',
  surveyingConsultingEngineers: 'مهندسین مشاور نقشه برداری',
  electricalConsultingEngineer: 'مهندس مشاور برق',
  computerConsultingEngineers: 'مهندسین مشاور کامپیوتر',
  waterResourcesConsultingEngineers: 'مهندسین مشاور منابع آب',
  buildingEngineers: 'مهندسین ساختمان',
  textileConsultingEngineers: 'مهندسین مشاور نساجی',
  facilityEngineering: 'مهندسی تاسیسات',
  electronicsAndTelecommunicationsConsultingEngineers:
    'مهندسین مشاور الکترونیک و مخابرات',
  technicalAndEngineeringLaboratoryEquipment: 'تجهیزات آزمایشگاه فنی و مهندسی',
  nonDestructiveTestingEquipmentAndSupplies: 'تجهیزات و لوازم بازرسی غیر مخرب',
  trackingSystemAndGpsProduction: 'تولید سیستم ردیابی و جی پی اس',
  surveyingEquipmentProduction: 'تولید لوازم نقشه برداری',
  plcProgramming: 'برنامه نویسی PLC',
  engineeringGroup: 'گروه مهندسی',
  surveying: 'نقشه برداری',
  technicalOffice: 'دفتر فنی',
  nonDestructiveTesting: 'بازرسی غیر مخرب',
  petrochemical: 'پتروشیمی',
  energyOptimization: 'بهینه سازی انرژی',
  oilAndPetrochemicalIndustries: 'صنایع نفت و پتروشیمی',
  oilGasAndPetrochemicalRefineryFittingsProduction:
    'تولید اتصالات پالایشگاهی نفت و گاز و پتروشیمی',
  oilGasAndPetrochemicalRefineryFittingsSales:
    'فروش اتصالات پالایشگاهی نفت و گاز و پتروشیمی',
  chemistryLaboratory: 'آزمایشگاه شیمی',
  industrialNonStickCoatingTeflonAndCeramic: 'پوشش نچسب صنعتی تفلون و سرامیک',
  polymer: 'پلیمر',
  polymerLaboratory: 'آزمایشگاه پلیمر',
  chemicalAndPetrochemicalIndustries: 'صنایع شیمی و پتروشیمی',
  oilGasAndPetrochemicalContractor: 'پیمانکار نفت و گاز و پتروشیمی',
  liquefiedGasCylinderProduction: 'تولید کپسول گاز مایع',
  liquefiedGasRegulator: 'رگلاتور گاز مایع',
  gasSupplyAndLiquefiedGasEquipment: 'گازرسانی و تجهیزات گاز مایع',
  heliumGas: 'گاز هلیوم',
  oxygenGasCylinderSaleAndCharging: 'فروش و شارژ کپسول گاز اکسیژن',
  liquefiedGasDistribution: 'توزیع گاز مایع',
  bitumenProduction: 'تولید قیر',
  bitumenSales: 'فروش قیر',
  oilSalesBranches: 'شعب فروش نفت',
  gasOilDistributionContractor: 'پیمانکار پخش گازوئیل',
  oilGasAndPetrochemicalPlantMaintenanceAndRepair:
    'نگهداری و تعمیر کارخانجات نفت و گاز و پتروشیمی',
  oilGasAndPetrochemicalRefineryEquipmentProduction:
    'تولید تجهیزات پالایشگاهی نفت و گاز و پتروشیمی',
  oilAndGasPipelineDesignAndImplementation:
    'طراحی و اجرای خطوط انتقال نفت و گاز',
  polymerIndustries: 'صنایع پلیمر',
  oilGasAndPetrochemicalProjectDesignAndManagement:
    'طراحی و مدیریت پروژه نفت و گاز و پتروشیمی',
  gasIndustries: 'صنایع گاز',
  oilGasAndPetrochemicalRefineryEquipmentSales:
    'فروش تجهیزات پالایشگاهی نفت و گاز و پتروشیمی',
  oilGasAndPetrochemicalProductsProduction:
    'تولید فرآورده نفت و گاز و پتروشیمی',
  oilGasAndPetrochemicalProductsSales: 'فروش فرآورده نفت و گاز و پتروشیمی',
  oilAndGasFieldsExplorationExtractionAndDevelopment:
    'اکتشاف، استخراج و توسعه میادین نفت و گاز',
  oilAndPetrochemicalPlantDesignAndConstruction:
    'طراحی و ساخت کارخانجات نفت و پتروشیمی',
  oilAndGasPipeStressRelieving: 'تنش زدایی لوله های نفت و گاز',
  plasticPolymer: 'پلیمر پلاستیک',
  machineToolsAndHardware: 'ماشین، ابزار، یراق',
  industrialToolsSales: 'فروش ابزار صنعتی',
  glassCuttingToolProduction: 'تولید ابزار شیشه بری',
  glassCuttingToolSales: 'فروش ابزار شیشه بری',
  craneRepair: 'تعمیر جرثقیل',
  dieselPurifierDevice: 'دستگاه تصفیه گازوئیلی',
  constructionToolsSales: 'فروش ابزار ساختمانی',
  industrialAndAgriculturalMachinerySales: 'فروش ماشین آلات صنعتی و کشاورزی',
  oilPurifierDevice: 'دستگاه تصفیه روغن',
  stoneCuttingEquipment: 'تجهیزات سنگبری',
  hydraulicAndPneumaticEquipment: 'تجهیزات هیدرولیک و پنوماتیک',
  powerToolRepair: 'تعمیر ابزار برقی',
  powerToolSales: 'فروش ابزار برقی',
  powerToolProduction: 'تولید ابزار برقی',
  industrialToolProduction: 'تولید ابزار صنعتی',
  constructionToolProduction: 'تولید ابزار ساختمانی',
  industrialMachineryAutomation: 'اتوماسیون ماشین آلات صنعتی',
  precisionInstrumentMechanicalTesting: 'تست مکانیکی ابزار دقیق',
  machineToolTechnicalServices: 'خدمات فنی ماشین ابزار',
  industrialMachineryRepair: 'تعمیر ماشین آلات صنعتی',
  industrialAndAgriculturalMachineryProduction:
    'تولید ماشین آلات صنعتی و کشاورزی',
  industrialGear: 'چرخ دنده صنعتی',
  industrialGearbox: 'گیربکس صنعتی',
  rubberLaboratoryEquipment: 'تجهیزات آزمایشگاهی لاستیک',
  industrialToolRepair: 'تعمیر ابزار صنعتی',
  parkAndAmusementParkEquipment: 'تجهیزات پارک و شهربازی',
  toolsAndHardwareProduction: 'تولید ابزار و یراق',
  blowMoldingPlastic: 'پلاستیک بادی',
  pumpSales: 'فروش پمپ',
  compressorSaleAndRental: 'فروش و اجاره کمپرسور',
  technicalInspection: 'بازرسی فنی',
  phototherapyDevice: 'دستگاه فتوتراپی',
  airAndLiquidDustFilterBag: 'کیسه غبارگیر هوا و مایعات',
  pumpProduction: 'تولید پمپ',
  drillAndElectricBit: 'دریل و مته برقی',
  weldingTools: 'ابزار آلات جوشکاری',
  sawSharpening: 'اره تیز کنی',
  weldingElectrode: 'الکترود جوشکاری',
  weldingMachineAndEquipment: 'دستگاه و تجهیزات جوشکاری',
  oxygenGasEquipment: 'تجهیزات گاز اکسیژن',
  gasLeakDetector: 'دستگاه نشت یاب گاز',
  fixedRotatingAndIndustrialWheel: 'چرخ ثابت گردان و صنعتی',
  goldMakingTools: 'ابزار طلا سازی',
  highPressureHose: 'شیلنگ فشار قوی',
  electricalAndElectronicsIndustry: 'صنعت برق و الکترونیک',
  electricMotorSaleAndRepair: 'فروش و تعمیر الکتروموتور',
  dieselGeneratorGeneratorAndPowerGeneratorSales:
    'فروش دیزل ژنراتور، ژنراتور و موتور برق',
  electricMotorRepair: 'تعمیر الکتروموتور',
  ups: 'یو پی اس',
  electronicCircuitEquipment: 'تجهیزات مدار الکترونیکی',
  electronicAndTelecommunicationComponentsAndSystems:
    'قطعات و سیستم الکترونیک و مخابرات',
  motorSpeedController: 'تنظیم کننده دور موتور',
  amplifierSales: 'فروش آمپلی فایر',
  encryptionAndIdentificationEquipment: 'تجهیزات رمزنگاری و تشخیص هویت',
  busDuctPowerDistributionAndTransmission: 'باسداکت توزیع برق و انتقال نیرو',
  electronicComponentsProduction: 'تولید قطعات الکترونیک',
  amplifierProduction: 'تولید آمپلی فایر',
  cassetteAndVideoTapeProduction: 'تولید نوار کاست و ویدیو',
  industrialOrBuildingElectricalEquipmentProduction:
    'تولید تجهیزات برق صنعتی یا ساختمانی',
  industrialOrBuildingElectricalEquipmentSales:
    'فروش تجهیزات برق صنعتی یا ساختمانی',
  solarPanelProduction: 'تولید پنل خورشیدی',
  solarPanelPoleMountDesignAndConstruction: 'طراحی ساخت پایه کوب پنل خورشیدی',
  electronicEquipmentProduction: 'تولید تجهیزات الکترونیک',
  dieselGeneratorGeneratorAndPowerGeneratorProduction:
    'تولید دیزل ژنراتور، ژنراتور و موتور برق',
  powerTransmissionTower: 'دکل انتقال نیرو',
  dieselGeneratorGeneratorAndPowerGeneratorRepair:
    'تعمیر دیزل ژنراتور، ژنراتور و موتور برق',
  electricalAndElectronicsIndustries: 'صنایع برق و الکترونیک',
  electricMotorProduction: 'تولید الکتروموتور',
  emergencyPower: 'برق اضطراری',
  industrialBattery: 'باتری صنعتی',
  electronicLightningRod: 'صاعقه گیر الکترونیکی',
  industrialMagnet: 'آهنربای صنعتی',
  electronicSystemProduction: 'تولید سیستم الکترونیک',
  industrialCapacitor: 'خازن صنعتی',
  powerDistributionAndTransmission: 'توزیع برق و انتقال نیرو',
  electronicEquipmentSales: 'فروش تجهیزات الکترونیک',
  electronicComponentsRepair: 'تعمیر قطعات الکترونیک',
  electronicsRelatedServices: 'خدمات وابسته به الکترونیک',
  electronicComponentsSales: 'فروش قطعات الکترونیک',
  barcode: 'بارکد',
  electronicBoardAssembly: 'مونتاژ برد الکترونیکی',
  solarPanelSales: 'فروش پنل خورشیدی',
  industrialElectricalEquipment: 'تجهیزات برق صنعتی',
  switchAndSocketProduction: 'تولید کلید و پریز',
  industrialConstruction: 'ساخت و ساز صنعتی',
  damAndCanalConstruction: 'احداث سد و کانال',
  automaticBarrier: 'راه بند اتوماتیک',
  asphaltPaving: 'آسفالت کاری',
  asphaltSales: 'فروش آسفالت',
  trafficLandscaping: 'محوطه سازی راهنمایی و رانندگی',
  pierConstruction: 'احداث اسکله',
  bridgeConstruction: 'احداث پل',
  airportConstruction: 'احداث فرودگاه',
  refineryConstruction: 'احداث پالایشگاه',
  railwayConstruction: 'احداث راه آهن',
  tunnelConstruction: 'احداث تونل',
  roadAndHighwayConstruction: 'راهسازی و جاده سازی',
  powerPlantConstruction: 'نیروگاه سازی',
  industrialDrafting: 'نقشه کشی صنعتی',
  marineStructure: 'سازه دریایی',
  concretePowerPoleConstruction: 'ساخت تیر سیمانی برق',
  steelShedAndSkeleton: 'سوله و اسکلت فلزی',
  workAtHeight: 'کار در ارتفاع',
  beautyProductsAndServices: 'محصولات و خدمات زیبایی',
  beautyAndCosmeticCenters: 'مراکز زیبایی و آرایشی',
  womensHairSalon: 'آرایشگاه زنانه',
  mensHairSalon: 'آرایشگاه مردانه',
  laserHairRemoval: 'لیزر موی زائد',
  solarium: 'سولاریوم',
  masseur: 'ماساژور',
  cosmeticAndHygienicProducts: 'محصولات آرایشی بهداشتی',
  cosmeticAndHygienicProductsSales: 'فروش محصولات آرایشی بهداشتی',
  cosmeticAndHygienicProductsRawMaterialsProduction:
    'تولید مواد اولیه محصولات آرایشی، بهداشتی',
  cosmeticAndHygienicProductsProduction: 'تولید محصولات آرایشی، بهداشتی',
  cosmeticAndHygienicProductsDistribution: 'پخش محصولات آرایشی، بهداشتی',
  cosmeticAndHygienicProductsPackaging: 'بسته بندی محصولات آرایشی بهداشتی',
  salonEquipmentAndSupplies: 'تجهیزات و لوازم آرایشگاهی',
  detergentIndustry: 'صنعت شوینده',
  cleanerAndDetergentSales: 'فروش پاک کننده و شوینده',
  cleanerAndDetergentProduction: 'تولید پاک کننده و شوینده',
  cleanerAndDetergentRawMaterials: 'مواد اولیه پاک کننده و شوینده',
  industrialCleanerAndDetergent: 'پاک کننده و شوینده صنعتی',
  cosmeticAndHygienicSuppliesQualityControl:
    'کنترل کیفیت لوازم آرایشی، بهداشتی',
  educationAndResearch: 'آموزش و پژوهش',
  publicSchools: 'مدارس دولتی',
  publicMixedPreSchool: 'پیش دبستان مختلط دولتی',
  publicBoysPreSchool: 'پیش دبستان پسرانه دولتی',
  publicGirlsPreSchool: 'پیش دبستان دخترانه دولتی',
  publicBoysElementarySchool: 'دبستان پسرانه دولتی',
  publicGirlsElementarySchool: 'دبستان دخترانه دولتی',
  publicBoysMiddleSchool: 'راهنمایی تحصیلی پسرانه دولتی',
  publicGirlsMiddleSchool: 'راهنمایی تحصیلی دخترانه دولتی',
  publicBoysHighSchool: 'دبیرستان پسرانه دولتی',
  publicGirlsHighSchool: 'دبیرستان دخترانه دولتی',
  publicGirlsSacrificeHighSchool: 'دبیرستان دخترانه ایثارگران',
  giftedHighSchool: 'دبیرستان تیزهوشان',
  publicBoysVocationalTechnicalSchool: 'هنرستان کار دانش پسرانه دولتی',
  publicGirlsVocationalTechnicalSchool: 'هنرستان کار دانش دخترانه دولتی',
  publicBoysVocationalSchool: 'هنرستان حرفه ای پسرانه دولتی',
  publicGirlsVocationalSchool: 'هنرستان حرفه ای دخترانه دولتی',
  publicBoysTechnicalSchool: 'هنرستان فنی پسرانه دولتی',
  publicGirlsTechnicalSchool: 'هنرستان فنی دخترانه دولتی',
  publicBoysPreUniversity: 'پیش دانشگاهی پسرانه دولتی',
  publicGirlsPreUniversity: 'پیش دانشگاهی دخترانه دولتی',
  publicBoysEducationalComplex: 'مجتمع آموزشی پسرانه دولتی',
  publicGirlsEducationalComplex: 'مجتمع آموزشی دخترانه دولتی',
  privateSchools: 'مدارس غیر انتفاعی',
  kindergartenAndPreparatory: 'مهد کودک، آمادگی',
  privateMixedPreSchool: 'پیش دبستان مختلط غیر انتفاعی',
  privateBoysPreSchool: 'پیش دبستان پسرانه غیر انتفاعی',
  privateGirlsPreSchool: 'پیش دبستان دخترانه غیر انتفاعی',
  privateBoysElementarySchool: 'دبستان پسرانه غیر انتفاعی',
  privateGirlsElementarySchool: 'دبستان دخترانه غیر انتفاعی',
  privateBoysMiddleSchool: 'راهنمایی تحصیلی پسرانه غیر انتفاعی',
  privateGirlsMiddleSchool: 'راهنمایی تحصیلی دخترانه غیر انتفاعی',
  privateBoysHighSchool: 'دبیرستان پسرانه غیر انتفاعی',
  privateGirlsHighSchool: 'دبیرستان دخترانه غیر انتفاعی',
  privateBoysPreUniversity: 'پیش دانشگاهی پسرانه غیر انتفاعی',
  privateGirlsPreUniversity: 'پیش دانشگاهی دخترانه غیر انتفاعی',
  privateBoysVocationalTechnicalSchool: 'هنرستان کار دانش پسرانه غیر انتفاعی',
  privateGirlsVocationalTechnicalSchool: 'هنرستان کار دانش دخترانه غیر انتفاعی',
  privateBoysVocationalSchool: 'هنرستان حرفه ای پسرانه غیر انتفاعی',
  privateGirlsVocationalSchool: 'هنرستان حرفه ای دخترانه غیر انتفاعی',
  privateBoysTechnicalSchool: 'هنرستان فنی پسرانه غیر انتفاعی',
  privateGirlsTechnicalSchool: 'هنرستان فنی دخترانه غیر انتفاعی',
  privateBoysEducationalComplex: 'مجتمع آموزشی پسرانه غیر انتفاعی',
  privateGirlsEducationalComplex: 'مجتمع آموزشی دخترانه غیر انتفاعی',
  specialSchools: 'مدارس خاص',
  rehabilitationCenterForExceptionalChildren: 'مرکز توانبخشی کودکان استثنایی',
  exceptionalElementarySchool: 'دبستان استثنایی',
  exceptionalMiddleSchool: 'راهنمایی تحصیلی استثنایی',
  exceptionalHighSchool: 'دبیرستان استثنایی',
  educationalAndResearchCenters: 'مراکز آموزشی و تحقیقاتی',
  university: 'دانشگاه',
  motorcycleTrainingCenter: 'آموزشگاه موتورسیکلت',
  heavyMachineryDrivingSchool: 'آموزشگاه رانندگی ماشین آلات سنگین',
  distanceLearningSchools: 'مدارس آموزش از راه',
  moldMakingTraining: 'آموزش قالب سازی',
  knowledgeBased: 'دانش بنیان',
  scienceAndEntranceExamInstitution: 'آموزشگاه علمی و کنکور',
  languageSchool: 'آموزشگاه زبان',
  drivingSchool: 'آموزشگاه رانندگی',
  defensiveDrivingTraining: 'آموزش رانندگی تدافعی',
  computerTraining: 'آموزش کامپیوتر',
  medicinalPlantsTraining: 'آموزش گیاهان دارویی',
  educationalResearchInstitute: 'موسسه آموزشی پژوهشی',
  medicalResearchCenter: 'مرکز تحقیقات پزشکی',
  researchAndInformation: 'تحقیقات و پژوهش، اطلاع رسانی',
  mobileRepairTraining: 'آموزش تعمیرات موبایل',
  hotelManagementTraining: 'آموزش هتل داری',
  tourismServicesTrainingCenter: 'آموزشگاه خدمات گردشگری',
  quranEducation: 'آموزش قرآن',
  biochemistry: 'بیوشیمی',
  typingTraining: 'آموزش تایپ',
  accountingAndAuditingTraining: 'آموزش حسابداری و حسابرسی',
  onlineTraining: 'آموزش اینترنتی',
  electronicEquipmentRepairTraining: 'آموزش تعمیر تجهیزات الکترونیکی',
  slacklineTraining: 'آموزش اسلک لاین',
  astronomyTraining: 'آموزش نجوم',
  guildHealthTrainingCenter: 'آموزشگاه بهداشت اصناف',
  alphabetTraining: 'آموزش الفبا',
  seminaryForBrothers: 'حوزه علمیه برادران',
  seminaryForSisters: 'حوزه علمیه خواهران',
  medicalEquipmentRepairTraining: 'آموزش تعمیر تجهیزات پزشکی',
  childrenLanguageSchool: 'آموزشگاه زبان کودکان',
  petTraining: 'آموزش حیوانات خانگی',
  educationalServices: 'خدمات آموزشی',
  spanishLanguageInstructor: 'مدرس زبان اسپانیایی',
  privateTutoring: 'تدریس خصوصی',
  educationalAndEntranceExamConsulting: 'مشاوره تحصیلی و کنکور',
  schoolSmartening: 'هوشمند سازی مدارس',
  educationalSpaceRental: 'اجاره فضای آموزشی',
  educationalAidsEquipment: 'تجهیزات کمک آموزشی',
  stationerySales: 'فروش لوازم التحریر',
  technicalAndVocationalTrainingCenters: 'مراکز آموزشی - فنی حرفه ای',
  photographyTraining: 'آموزش عکاسی',
  cookingTraining: 'آموزش آشپزی',
  calligraphyTraining: 'آموزش خوشنویسی',
  womensTailoringTraining: 'آموزش خیاطی بانوان',
  technicalAndVocationalTrainingCenter: 'آموزشگاه فنی و حرفه ای',
  mensTailoringTraining: 'آموزش خیاطی آقایان',
  weavingTrainingCenter: 'آموزشگاه بافندگی',
  womensHairdressingTraining: 'آموزشگاه آرایش بانوان',
  mensHairdressingTraining: 'آموزشگاه آرایش آقایان',
  actingAndMakeupTraining: 'آموزش بازیگری و گریم',
  sewingAndEmbroideryTraining: 'آموزش خیاطی و گلدوزی',
  artInstitute: 'آموزشگاه هنر',
  carpetWeavingTraining: 'آموزش قالی بافی',
  goldMakingTraining: 'آموزش طلا سازی',
  paintingTraining: 'آموزش نقاشی',
  bagShoeAndBeltMakingTraining: 'آموزش دوزندگی کیف و کفش و کمربند',
  flowerMakingAndFloristryTraining: 'آموزش گلسازی و گل آرایی',
  speedReadingAndLearningTraining: 'آموزش تندخوانی و یادگیری',
  draftingTraining: 'آموزش نقشه کشی',
  designAndArchitectureTraining: 'آموزش طراحی و معماری',
  toys: 'اسباب بازی',
  toysSales: 'فروش اسباب بازی',
  rechargeableCarRepair: 'تعمیر ماشین شارژی',
  dollSales: 'فروش عروسک',
  balloonSales: 'فروش بادکنک',
  toyRepair: 'تعمیر اسباب بازی',
  rechargeableCar: 'ماشین شارژی',
  rechargeableMotorcycle: 'موتور شارژی',
  sportsTrainingCenters: 'مراکز آموزشی - ورزش',
  volleyballTraining: 'آموزش والیبال',
  swimmingTraining: 'آموزش شنا',
  flightTraining: 'آموزش پرواز',
  divingTraining: 'آموزش غواصی',
  skateTraining: 'آموزش اسکیت',
  skiTraining: 'آموزش اسکی',
  tennisTraining: 'آموزش تنیس',
  selfDefenseTraining: 'آموزش دفاع شخصی',
  electronicsAndDigital: 'الکترونیک و دیجیتال',
  digitalGoods: 'کالای دیجیتال',
  mobilePhoneSaleAndRepair: 'فروش و تعمیر موبایل',
  simCardSales: 'فروش سیم کارت',
  laptopSales: 'فروش لپ تاپ',
  computerHardwareComponentsSales: 'فروش قطعات سخت افزار کامپیوتر',
  computerPeripheralsSales: 'فروش لوازم جانبی کامپیوتر',
  officeMachinerySales: 'فروش ماشین اداری',
  cameraAndPhotographyEquipmentSaleAndRepair:
    'فروش و تعمیر دوربین عکاسی و فیلم برداری',
  photographyEquipmentSales: 'فروش لوازم عکاسی',
  playstationAndGameConsoleSales: 'فروش پلی استیشن و کنسول بازی',
  softwareAndGameCdSales: 'فروش سی دی نرم افزار و بازی',
  softwareSales: 'فروش نرم افزار',
  cassetteAndVideoTapeSales: 'فروش نوار کاست و ویدیو',
  mobilePhoneProduction: 'تولید موبایل',
  mobilePhoneAccessories: 'لوازم جانبی موبایل',
  officeMachineryProduction: 'تولید ماشین اداری',
  officeMachinerySupplies: 'لوازم ماشین اداری',
  officeMachineryRepair: 'تعمیر ماشین اداری',
  laptopRepair: 'تعمیر لپ تاپ',
  photographyEquipmentProduction: 'تولید لوازم عکاسی',
  playstationAndGameConsoleRepair: 'تعمیر پلی استیشن و کنسول بازی',
  computerPeripheralEquipmentRepair: 'تعمیر تجهیزات جانبی کامپیوتر',
  softwareDistribution: 'پخش نرم افزار',
  electronicsAndDigitalServices: 'خدمات الکترونیک و دیجیتال',
  computerServices: 'خدمات کامپیوتر',
  medicalSoftware: 'نرم افزار پزشکی',
  internetCafe: 'کافی نت',
  websiteDesign: 'طراحی وب سایت',
  domainRegistrationAndWebHosting: 'ثبت دامنه و میزبانی وب',
  programming: 'برنامه نویسی',
  onlineStore: 'فروشگاه اینترنتی',
  communicationServicesCenter: 'مرکز خدمات ارتباطی',
  internetAccessServicesIsp: 'خدمات دسترسی به اینترنت ISP',
  networkingServices: 'خدمات شبکه',
  networkEquipmentSales: 'فروش تجهیزات شبکه',
  networkEquipmentProduction: 'تولید تجهیزات شبکه',
  computerHardwareComponentsProduction: 'تولید قطعات سخت افزار کامپیوتر',
  computerHardwareComponentsRepair: 'تعمیر قطعات سخت افزار کامپیوتر',
  telecommunicationCenter: 'مرکز مخابراتی',
  telecommunicationEquipmentSaleAndInstallation: 'فروش و نصب تجهیزات مخابراتی',
  telecommunicationEquipmentProduction: 'تولید تجهیزات مخابراتی',
  telephoneAndTelecommunicationEquipmentRepair: 'تعمیر تلفن و تجهیزات مخابراتی',
  managementInformationSystem: 'سیستم اطلاعات مدیریت',
  computerGameDesignAndProduction: 'طراحی و تولید بازی های کامپیوتری',
  electronicEquipmentRepair: 'تعمیر تجهیزات الکترونیک',
  electricalAppliancesSaleAndRepair: 'فروش و تعمیر لوازم برقی',
  electricalAppliancesProductionAndDistribution: 'تولید و پخش لوازم برقی',
  virtualOfficeOffice: 'دفتر کار مجازی',
  cdServices: 'خدمات سی دی',
  hardwareLock: 'قفل سخت افزاری',
  softwareLock: 'قفل نرم افزار',
  transportation: 'حمل و نقل',
  transportationServices: 'خدمات حمل و نقل',
  internationalTransportation: 'حمل و نقل بین المللی',
  wagonManufacturing: 'واگن سازی',
  railwayEquipment: 'تجهیزات ریلی',
  maritimeTransport: 'حمل و نقل دریایی',
  fluidMaterialsTransport: 'حمل و نقل مواد سیال',
  livestockAndPoultryTransport: 'حمل و نقل دام و طیور',
  cementTransport: 'حمل و نقل سیمان',
  craneTransport: 'حمل و نقل با جرثقیل',
  trailerTransport: 'حمل و نقل با تریلی',
  cargoTransport: 'حمل و نقل بار',
  agencyAndPostOffice: 'آژانس و دفتر پستی',
  intelligentTransportationSystem: 'سیستم حمل و نقل هوشمند',
  cargoTerminal: 'بنگاه باراندازی',
  maritimeServices: 'خدمات دریایی',
  metroServices: 'خدمات مترو',
  parking: 'پارکینگ',
  transportationVehicles: 'وسایل حمل و نقل',
  landTransport: 'حمل و نقل زمینی',
  railwayStation: 'ایستگاه راه آهن',
  brtStation: 'ایستگاه بی آر تی',
  busStation: 'ایستگاه اتوبوس',
  intraCityBusTerminal: 'پایانه اتوبوسرانی درون شهری',
  metroStation: 'ایستگاه مترو',
  taxiService: 'تاکسی سرویس',
  taxiTerminal: 'پایانه تاکسیرانی',
  carRental: 'اجاره خودرو',
  busAndMinibusRental: 'کرایه اتوبوس و مینی بوس',
  motorcycleCourier: 'پیک موتوری',
  internetTaxi: 'تاکسی اینترنتی',
  airTransport: 'حمل و نقل هوایی',
  airlines: 'خطوط هوایی',
  airport: 'فرودگاه',
  shipping: 'کشتیرانی',
  passengerPort: 'بندر مسافربری',
  travelAndTourism: 'سفر و گردشگری',
  accommodation: 'اقامت',
  ecotourism: 'بومگردی',
  hotel: 'هتل',
  suiteVilla: 'سوئیت ویلا',
  apartmentHotel: 'هتل آپارتمان',
  guestHouse: 'مهمانخانه',
  guesthouseAndPension: 'مهمانپذیر و پانسیون',
  inn: 'مسافرخانه',
  teacherHouseAndWelfareCenter: 'خانه معلم و مرکز رفاهی',
  studentDormitory: 'خوابگاه دانشجویی',
  travelServices: 'خدمات مسافرتی',
  passengerTransportCompany: 'شرکت مسافربری',
  travelAgency: 'آژانس مسافرتی',
  airlineAgency: 'آژانس هواپیمایی',
  immigrationServices: 'خدمات مهاجرت',
  handicraftsSales: 'فروش صنایع دستی',
  handicraftsProduction: 'تولید صنایع دستی',
  railway: 'راه آهن',
  travelTerminal: 'پایانه سفر',
  welfareComplex: 'مجتمع رفاهی',
  recreationalPlaces: 'اماکن تفریحی',
  culturalSportsRecreationalComplex: 'مجموعه فرهنگی ورزشی تفریحی',
  amusementPark: 'شهربازی',
  park: 'پارک',
  recreationalCenters: 'مراکز تفریحی',
  mineralSpring: 'چشمه آب معدنی',
  lake: 'دریاچه',
  zoo: 'باغ وحش',
  gameNet: 'گیم نت',
  sightseeingPlaces: 'اماکن دیدنی',
  ancientMonumentsAndHistoricalBuildings: 'آثار باستانی و بنای تاریخی',
  palace: 'کاخ',
  museum: 'موزه',
  mosque: 'مسجد',
  hussainiaAndTekyeh: 'حسینیه و تکیه',
  imamzadehAndPilgrimageSite: 'امامزاده و زیارتگاه',
  synagogue: 'کنیسه',
  church: 'کلیسا',
  printingAndAdvertising: 'چاپ و تبلیغات',
  printingAndPublishing: 'چاپ و نشر',
  silkScreen: 'سیلک اسکرین',
  printingHouse: 'چاپخانه',
  bookbinding: 'صحافی',
  lithography: 'لیتوگرافی',
  plotterAndColorPrint: 'پلات و پرینت رنگی',
  designAndPrint: 'طراحی و چاپ',
  typesettingAndTyping: 'حروف چینی و تایپ',
  notebookMaking: 'دفتر سازی',
  embossing: 'جلد کوبی',
  envelopeMaking: 'پاکت سازی',
  bookDistribution: 'پخش کتاب',
  paperCutting: 'برشکاری کاغذ',
  envelopeSales: 'فروش پاکت',
  publications: 'انتشارات',
  periodical: 'نشریه',
  printingAndPublishingSupplies: 'لوازم چاپ و نشر',
  bookstore: 'کتابفروشی',
  paperAndCardboardSales: 'فروش کاغذ و مقوا',
  paperAndCardboardRawMaterials: 'مواد اولیه کاغذ و مقوا',
  paperAndCardboardProduction: 'تولید کاغذ و مقوا',
  poster: 'پوستر',
  envelopeProduction: 'تولید پاکت',
  photostatProduction: 'تولید عکس برگردان',
  sticker: 'برچسب',
  hologram: 'هولوگرام',
  flag: 'پرچم',
  advertising: 'تبلیغات',
  contentProduction: 'تولید محتوا',
  advertisingAgencyAndCompany: 'آژانس و شرکت تبلیغاتی',
  statuette: 'تندیس',
  advertisingBoard: 'تابلو تبلیغاتی',
  promotionalGift: 'هدیه تبلیغاتی',
  advertisingTeaserProduction: 'تولید تیزر تبلیغاتی',
  exhibitionBoothDesignAndImplementation: 'طراحی و اجرای غرفه نمایشگاهی',
  computerDesignAndAnimation: 'طراحی کامپیوتری و انیمیشن',
  industrialPhotography: 'عکاسی صنعتی',
  publicationAdvertisementAcceptanceAgency: 'نمایندگی پذیرش آگهی نشریات',
  information: 'اطلاع رسانی',
  graphicDesign: 'طراحی گرافیکی',
  graphicDesigner: 'گرافیست',
  filmMaking: 'فیلم سازی',
  advertisingTeaserNarrator: 'گوینده تیزر تبلیغاتی',
  smsValueAddedService: 'سرویس ارزش افزوده پیام کوتاه - SMS',
  hiringAdvertisingConsultant: 'استخدام مشاور تبلیغاتی',
  stampAndLicensePlate: 'مهر و پلاک',
  shoppingBag: 'ساک دستی',
  marketing: 'بازاریابی',
  sportsCultureArt: 'ورزش، فرهنگ، هنر',
  cultureAndArt: 'فرهنگ و هنر',
  library: 'کتابخانه',
  cinema: 'سینما',
  theater: 'تئاتر',
  culturalCenter: 'فرهنگسرا',
  artGallery: 'گالری هنری',
  musicalInstrumentSales: 'فروش ساز',
  musicSchool: 'آموزشگاه موسیقی',
  paintingGallery: 'نگارخانه',
  cultureHouse: 'خانه فرهنگ',
  culturalInstitute: 'موسسه فرهنگی',
  storytellingAndPardeKhani: 'نقالی و پرده خوانی',
  theaterGroup: 'گروه نمایش',
  painting: 'تابلو نقاشی',
  newspaperAgency: 'روزنامه فروشی',
  videoClub: 'ویدیو کلوپ',
  visualArts: 'هنر تجسمی',
  soundRecordingAndDubbingStudio: 'استودیو صدابرداری و صداگذاری',
  filmingOrDubbingStudio: 'استودیو فیلمبرداری یا صداگذاری',
  artSupplies: 'لوازم هنری',
  flowerMakingAndFloristry: 'گلسازی و گل آرایی',
  socialClub: 'باشگاه اجتماعی',
  culturalAndArtConsulting: 'مشاوره فرهنگی و هنری',
  audioBook: 'کتاب صوتی',
  performingArts: 'هنرهای نمایشی',
  sports: 'ورزش',
  sportsClub: 'باشگاه ورزشی',
  sportsCoach: 'مربی ورزش',
  footballClub: 'باشگاه فوتبال',
  bodybuildingClub: 'باشگاه بدنسازی',
  aerobicsClub: 'باشگاه ایروبیک',
  martialArtsClub: 'باشگاه رزمی',
  billiardClub: 'باشگاه بیلیارد',
  tennisClub: 'باشگاه تنیس',
  equestrianClub: 'باشگاه سوارکاری',
  swimmingPoolAndSauna: 'استخر و سونا',
  stadium: 'ورزشگاه',
  yoga: 'یوگا',
  paintball: 'پینت بال',
  athlete: 'ورزشکار',
  sportsEquipmentAndSupplies: 'تجهیزات و لوازم ورزشی',
  sportsMat: 'تشک ورزشی',
  proteinPowderSales: 'فروش پودر پروتئین',
  fishingSupplies: 'لوازم ماهیگیری',
  huntingSupplies: 'لوازم شکار',
  mountaineeringSupplies: 'لوازم کوهنوردی',
  aviationSupplies: 'لوازم هوانوردی',
  sportsHallEquipment: 'تجهیزات سالن ورزشی',
  medicalSportsEquipmentSales: 'فروش لوازم ورزشی پزشکی',
  vehiclesAndTransportation: 'خودرو و وسایل نقلیه',
  passengerCar: 'خودرو سواری',
  carShowroom: 'نمایشگاه خودرو',
  carBatteryProduction: 'تولید باتری خودرو',
  carBearingAndBallBearingProduction: 'تولید یاتاقان و بلبرینگ خودرو',
  shotProduction: 'تولید ساچمه',
  shotSales: 'فروش ساچمه',
  carBuyingAndSelling: 'خرید و فروش خودرو',
  autoSparePartsSales: 'فروش لوازم یدکی خودرو',
  carRimAndTireSales: 'فروش رینگ و لاستیک خودرو',
  carRepairAndTuneUpShop: 'تعمیرگاه و تون آپ خودرو',
  carBatteryAndElectrical: 'باطری سازی و برقکاری خودرو',
  carManufacturing: 'خودروسازی',
  autoSparePartsProduction: 'تولید لوازم یدکی خودرو',
  autoSparePartsDistribution: 'پخش لوازم یدکی خودرو',
  carLeasing: 'لیزینگ خودرو',
  motorcycleAndBicycle: 'موتور سیکلت و دوچرخه',
  motorcycleSales: 'فروش موتورسیکلت',
  motorcycleSparePartsSales: 'فروش لوازم یدکی موتورسیکلت',
  bicycleSales: 'فروش دوچرخه',
  motorcycleAndBicycleSparePartsSales: 'فروش قطعات یدکی موتورسیکلت و دوچرخه',
  motorcycleAgency: 'نمایندگی موتورسیکلت',
  authorizedMotorcycleRepairShop: 'تعمیرگاه مجاز موتورسیکلت',
  motorcycleAndBicycleRepair: 'تعمیر موتورسیکلت و دوچرخه',
  motorcycleProduction: 'تولید موتورسیکلت',
  bicycleProduction: 'تولید دوچرخه',
  motorcycleSparePartsProduction: 'تولید لوازم یدکی موتورسیکلت',
  heavyVehicles: 'وسایل نقلیه سنگین',
  heavyVehiclesSales: 'فروش وسایل نقلیه سنگین',
  heavyMachinerySparePartsSales: 'فروش لوازم یدکی ماشین آلات سنگین',
  heavyMachineryRental: 'کرایه ماشین آلات سنگین',
  heavyVehiclesSpareParts: 'لوازم یدکی وسایل نقلیه سنگین',
  heavyVehiclesRepairAndAfterSalesServices:
    'تعمیرگاه و خدمات پس از فروش وسایل نقلیه سنگین',
  heavyVehiclesProduction: 'تولید وسایل نقلیه سنگین',
  transportationVehiclesServices: 'خدمات وسایل نقلیه',
  authorizedCarDealer: 'نمایندگی مجاز خودرو',
  roadsideAssistance: 'امداد خودرو',
  vehicleTechnicalInspectionCenters: 'مراکز معاینه فنی خودرو',
  carLicensePlateReplacement: 'تعویض پلاک خودرو',
  carWash: 'کارواش',
  roundTheClockCarWash: 'کارواش شبانه روزی',
  gasStation: 'پمپ بنزین',
  gasPump: 'پمپ گاز',
  carAccessories: 'تزئینات خودرو',
  fiberglassServices: 'خدمات فایبرگلاس',
  carGasConversion: 'گازسوز کردن خودرو',
  trafficSigns: 'علائم راهنمایی و رانندگی',
  carBodyBuilding: 'ساخت اتاق خودرو',
  damagedCarSales: 'فروش خودرو تصادفی',
  carPaint: 'رنگ اتومبیل',
  carExpert: 'کارشناس خودرو',
  agricultureAndLivestock: 'کشاورزی و دامپروری',
  agriculture: 'کشاورزی',
  greenhouseEquipment: 'تجهیزات گلخانه ای',
  agriculturalAndGardeningEquipment: 'تجهیزات کشاورزی و باغبانی',
  agriculturalServices: 'خدمات کشاورزی',
  soilScienceLaboratory: 'آزمایشگاه خاک شناسی',
  greenhouseAndPlantCultivation: 'گلخانه و پرورش گل و گیاه',
  agriculturalProducts: 'محصولات کشاورزی',
  agroIndustry: 'کشت و صنعت',
  agriculturalMachinerySales: 'فروش ماشین آلات کشاورزی',
  watershedManagement: 'آبخیزداری',
  animalHusbandry: 'دامپروری',
  livestockFarming: 'دامپروری و دامداری',
  herbalMedicineForLivestockAndPoultryProduction: 'تولید دارو گیاهی دام و طیور',
  livestockPoultryAndAquaticsFeedSales: 'فروش خوراک دام و طیور و آبزیان',
  fisheries: 'پرورش شیلات',
  poultryFarming: 'پرورش طیور',
  livestockAndPoultryLaboratory: 'آزمایشگاه دام و طیور',
  petBoarding: 'پانسیون حیوانات خانگی',
  slaughterhouse: 'کشتارگاه',
  dogBreeding: 'پرورش سگ',
  importAndExportOfCCTVEquipment: 'واردات صادرات تجهیزات مداربسته',
};
